export const work = {
  offlineMove: {
    saved: "Enregistré, sera envoyé dès que vous serez en ligne.",
  },
  whoWhen: {
    who: "Qui",
    when: "Quand",
    whenPlaceholder: "Choisir un jour",
    change: "Modifier",
    applyToAll: "Appliquer à tous",
    done: "Terminé",
    pickContractorTitle: "Choisir un prestataire",
    pickContractorsTitle: "Choisir les prestataires à consulter",
    summary: {
      person: "{{name}} s’en charge",
      teamQueue: "Votre équipe, personne choisi pour l’instant",
      contractor: "{{name}} s’en charge",
      pickContractor: "Choisir un prestataire",
      pickContractors: "Choisir les prestataires à consulter",
      quotes_one: "Demander un devis à {{count}} prestataire",
      quotes_other: "Demander des devis à {{count}} prestataires",
      quotes_many: "Demander des devis à {{count}} prestataires",
    },
    sheetTitle: "Créer un travail",
    title: "Titre",
    brief: "Descriptif",
    moreDetails: "Plus de détails",
    create: "Créer",
    created: "Travail créé et transmis",
    quotesSent_one: "Travail créé. Demande de devis envoyée à {{count}} prestataire",
    quotesSent_other: "Travail créé. Demandes de devis envoyées à {{count}} prestataires",
    quotesSent_many: "Travail créé. Demandes de devis envoyées à {{count}} prestataires",
    notToldTitle: "Attribué, mais non prévenu",
    notToldBody: "{{name}} a le travail mais n’a ni e-mail ni compte, personne ne l’a donc prévenu. Prévenez-le vous-même.",
    failedTitle: "Impossible de créer le travail",
    failedBody: "Veuillez réessayer.",
  },
  scope: { contractorWork: "Travaux sous-traités" },
  reportsTab: { all: "Tous les rapports", versionsTitle: "Versions {{kind}}", openReport: "Ouvrir {{kind}}", noVersions: "Aucune version enregistrée pour l’instant.", more: "{{n}} de plus dans {{kind}}", withSubJobs: "Travaux avec sous-tâches" },
queueRow: {
secondaryDefault: "Démarrer",
you: "Vous",
raisedBy: "Signalé par {{name}}",
planned: "Planifié {{when}}",
unassigned: "Non assigné",
showFewerStatusLabels: "Afficher moins d'étiquettes d'état",
showMoreStatusLabels_one: "Afficher {{count}} étiquette d’état de plus : {{labels}}",
showMoreStatusLabels_other: "Afficher {{count}} étiquettes d’état de plus : {{labels}}",
moreActionsForA11y: "Plus d'actions pour {{title}}",
secondaryActionA11y: "{{action}} {{title}}",
openItemA11y: "Ouvrir {{title}}",
open: "Ouvrir",
showMoreStatusLabels_many: "Afficher {{count}} étiquettes d’état de plus : {{labels}}",
},
jobChecks: {
  inline: {
    hide: "Masquer les réponses",
    loading: "Chargement des réponses…",
    loadFailed: "Impossible de charger les réponses. Rouvrez l’intervention pour réessayer.",
    failed: "Échec",
    skipped: "Ignoré",
    photos_one: "{{count}} photo",
    photos_many: "{{count}} photos",
    photos_other: "{{count}} photos",
  },
stageLabel: {
pre: "Contrôle préalable",
post: "Post-vérification",
standalone: "Contrôle",
},
stageLabelLower: {
pre: "contrôle préalable",
post: "post-vérification",
standalone: "contrôle",
},
round: "Tour {{n}}",
noneYet: "Aucune pour l’instant",
removeStageA11y: "Retirer le {{stage}}",
attachFailedTitle: "Intervention créée, mais le {{stage}} n’a pas pu être joint",
attachFailedBody: "Ajoutez-le depuis l’intervention.",
attach: {
addAs: "Ajouter comme {{stage}}",
chooseChecklist: "Choisir une liste de contrôle",
attachTemplateAsA11y: "Joindre {{name}} comme {{stage}}",
chooseFirstA11y: "Choisissez d’abord une liste de contrôle",
attachAsA11y: "Joindre comme {{stage}}",
loadingTitle: "Chargement de vos listes de contrôle…",
loadingBody: "Un instant — récupération de la bibliothèque.",
noMatchTitle: "Aucune liste de contrôle ne correspond",
noMatchBody: "Essayez une recherche plus courte, ou effacez-la pour tout voir.",
emptyTitle: "Aucune liste de contrôle à joindre pour l’instant",
emptyBody: "N’importe quelle liste de contrôle peut servir de contrôle. Créez-en une et elle apparaîtra ici.",
},
resultLabel: {
pass: "Réussi",
flag: "À signaler",
fail: "Échec",
},
stepCount_one: "{{completed}}/{{count}} étape",
stepCount_other: "{{completed}}/{{count}} étapes",
gateReasonSingle: "Le {{stage}} « {{name}} » doit être complété {{verb}}.",
gateReasonMultiple: "{{count}} {{noun}} doivent être terminés {{verb}}.",
checksNoun: "contrôles",
beforeSubmitted: "avant la soumission de cette intervention",
beforeStarted: "avant le début de cette intervention",
gateDefaultReason: "Un contrôle doit d'abord être terminé.",
templateStepCount_one: "{{count}} étape",
templateStepCount_other: "{{count}} étapes",
historyOneFailure: "1 échec sur {{span}}.",
historyFailures_one: "{{count}} échec sur {{span}}.",
historyFailures_many: "{{count}} échecs sur {{span}}.",
historyFailures_other: "{{count}} échecs sur {{span}}.",
historyOneFlag: "1 élément signalé sur {{span}}.",
historyFlags_one: "{{count}} élément signalé sur {{span}}.",
historyFlags_many: "{{count}} éléments signalés sur {{span}}.",
historyFlags_other: "{{count}} éléments signalés sur {{span}}.",
historyNoFailures: "Aucune défaillance sur {{span}}.",
spanLastCheck: "le dernier contrôle",
spanLastChecks_one: "le dernier contrôle",
spanLastChecks_many: "les {{count}} derniers contrôles",
spanLastChecks_other: "les {{count}} derniers contrôles",
completedStatus: "Terminé {{progress}}",
notFinishedStatus: "{{progress}} — pas terminé",
reworkRequested: "Reprise demandée",
section: {
heading: "Ce dont cette intervention a besoin",
addCheckA11y: "Ajouter un contrôle à cette intervention",
addCheck: "Ajouter un contrôle",
tryAgainA11y: "Réessayer de charger les contrôles",
tryAgain: "Réessayer",
noChecksTitle: "Aucun contrôle sur cette intervention",
headingPlan: "Ce dont chaque intervention a besoin",
noChecksTitlePlan: "Aucun contrôle pour l’instant",
noChecksBody: "Joignez une liste de contrôle à exécuter avant le début ou après la fin des travaux, et ses réponses deviennent la preuve que cette intervention a été effectuée.",
required: "Obligatoire",
round: "Tour {{number}}",
stop: "Arrêt {{number}} : {{name}}",
checkFallback: "Contrôle",
openCheckA11y: "{{verb}} {{stage}} {{name}}. {{progress}}.",
review: "Vérifier",
continueVerb: "Continuer",
start: "Démarrer",
reviewCheck: "Vérifier le contrôle",
continueCheck: "Continuer la vérification",
startCheck: "Démarrer la vérification",
removeCheckA11y: "Supprimer {{stage}} {{name}}",
remove: "Supprimer",
},
stepCount_many: "{{completed}}/{{count}} étapes",
templateStepCount_many: "{{count}} étapes",
},
requestActivityStream: {
  tidyFailedBody: "Réessayez dans un instant ou envoyez-le tel quel.",
  tidyFailedTitle: "Impossible de retravailler le message",
  tidiedReview: "Vérifiez-le avant de l’envoyer.",
  tidiedTitle: "Message retravaillé",
  tidyUp: "Retravailler avec l’IA",
  stop: "Arrêter",
  noAccountHint: "{{name}} n’a pas de compte et ne verra pas les messages ici. Utilisez Poser une question pour lui écrire par e-mail.",
  notSent: "Non envoyé. Vérifiez votre connexion et touchez à nouveau Envoyer.",
theRequesterDefault: "Le demandeur",
theTeamDefault: "L'équipe",
raisedThis: "{{who}} a créé cette demande · {{time}}",
you: "Vous",
noMessagesYetOperator: "Pas encore de messages — répondez ci-dessous pour démarrer la conversation.",
noMessagesYetRequester: "Pas encore de messages — envoyez-en un ci-dessous et l'équipe vous répondra ici.",
removePhotoA11y: "Supprimer la photo",
replyOrLogNoteA11y: "Écrire au demandeur",
messageTeamA11y: "Message à l'équipe",
replyOrLogNotePlaceholder: "Message au demandeur (il le voit)…",
messageTeamPlaceholder: "Envoyez un message à l’équipe…",
sending: "Envoi…",
send: "Envoyer",
sendReplyA11y: "Envoyer la réponse",
signInRequiredTitle: "Connexion requise",
signInToAttachPhotos: "Connectez-vous pour joindre des photos.",
uploadFailedTitle: "Échec du téléchargement",
couldNotAttachPhoto: "Impossible de joindre la photo.",
},
requestDetailHeader: {
noPriority: "Aucune priorité",
assetNotSet: "Actif non défini",
notSet: "Non défini",
tileLabel: {
asset: "Actif",
requester: "Demandeur",
priority: "Priorité",
scheduled: "Planifié",
respondBy: "Répondre avant le",
},
openTileA11y: "Ouvrir {{label}} : {{value}}",
escalated: "Remontée · 48h+",
nextPrefix: "Suivant : ",
},
repairDecisionPanel: {
yourDecisions: "Vos décisions",
progress: "Décisions : {{decided}} sur {{total}}",
approveRecommendationTitle: "D'accord avec tous les éléments ?",
approveRecommendationHint: "Marque tous les éléments comme approuvés. Vous pouvez encore en refuser avant de signer.",
applying: "Application en cours...",
approveRecommended: "Tout approuver",
urgent: "Urgent",
highPriority: "Haute priorité",
noEvidence: "Aucune preuve",
possibleDuplicate: "Doublon possible",
approved: "Approuvé",
declined: "Refusé",
awaitingDecision: "En attente de décision",
approve: "Approuver",
decline: "Refuser",
approveItemA11y: "approuver {{label}}",
declineItemA11y: "Refuser {{label}}",
seeEvidenceA11y: "Voir les preuves pour {{label}}",
openAllEvidenceA11y: "Ouvrir toutes les preuves pour {{label}}",
evidenceThumbA11y: "{{label}} preuve {{number}}",
declineNoteA11y: "Note de refus pour {{label}}",
declineNotePlaceholder: "Pourquoi refusez-vous ? (facultatif — partagé avec l'équipe)",
photoCount_one: "{{count}} photo",
photoCount_other: "{{count}} photos",
videoCountClause_one: " · {{count}} vidéo",
videoCountClause_other: " · {{count}} vidéos",
viewDetailsClause: " · Voir les détails",
approvedTotal: "Total approuvé : {{amount}}",
nothingApprovedYet: "Rien d'approuvé pour l'instant",
photoCount_many: "{{count}} photos",
videoCountClause_many: " · {{count}} vidéos",
},
workIntelligenceActions: {
analyzeEvidence: "Analyser les photos",
useComment: "Utiliser le commentaire",
draftComment: "Rédiger un commentaire",
suggestAction: "Suggérer une action",
useSuggestion: "Utiliser la suggestion",
createJobFromSuggestion: "Créer une intervention à partir d'une suggestion",
createJob: "Créer une intervention",
assessEvidence: "Évaluer les preuves",
useNote: "Utiliser la note",
couldNotCompleteRequest: "Impossible de terminer la demande.",
unexpectedError: "Erreur inattendue",
aiSuggestionWithConfidence: "Suggestion IA · {{percent}} % de confiance",
aiSuggestion: "Suggestion IA",
priorityLabel: "Priorité : {{priority}}",
riskLabel: "Risque : {{band}} ({{score}}/100)",
dismissSuggestionA11y: "Ignorer la suggestion",
dismiss: "Ignorer",
},
reportAccessRequests: {
roleLabel: {
owner: "Propriétaire",
tenant: "Locataire / occupant",
landlord: "Propriétaire bailleur",
manager: "Agent gestionnaire",
client: "Client",
contractor: "Prestataire",
other: "Autre",
},
headerCount_one: "Demande d'accès au rapport · {{count}}",
headerCount_other: "Demandes d'accès au rapport · {{count}}",
someoneFallback: "Quelqu'un",
assetFallback: "Actif",
approve: "Approuver",
decline: "Refuser",
couldNotCompleteTitle: "Impossible de terminer",
tryAgainMoment: "Veuillez réessayer dans un instant.",
alreadyDecidedTitle: "Déjà décidé",
alreadyDecidedMessage: "Quelqu'un d'autre a déjà répondu à cette demande.",
notPermittedTitle: "Non autorisé",
notPermittedMessage: "Vous n'êtes pas autorisé à décider de cette demande.",
accessApproved: "Accès au rapport approuvé",
requestDeclined: "Demande refusée",
headerCount_many: "Demandes d'accès au rapport · {{count}}",
},
assetRequestDetailScreen: {
actions: {
openJob: "Ouvrir l'intervention",
openInspection: "Ouvrir l'inspection",
approve: "Approuver",
replyFirstTitle: "Marquer comme répondu et continuer ?",
replyFirstBody: "Ce dossier attend le client. Continuer enregistre sa réponse, puis poursuit.",
replyFirstCancel: "Pas maintenant",
replyFirstConfirm: "Marquer comme répondu",
decline: "Refuser",
replied: "Noter sa réponse",
ask: "Poser une question",
inspect: "Inspecter",
createWork: "Créer une intervention",
close: "Clôturer la demande",
},
assistant: {
title: "Assistant",
turnIntoWork: "Transformer en travail",
suggestNextSteps: "Suggérer les prochaines étapes",
requestAssistantTitle: "Assistant de demande",
promptWithTitle: "Aidez-moi à examiner cette demande (« {{title}} ») et à décider s'il faut poser une question, l'inspecter, créer un travail ou la clôturer.",
promptDefault: "Aidez-moi à examiner cette demande et à décider s'il faut poser une question, l'inspecter, créer un travail ou la clôturer.",
},
capture: {
notSavedTitle: "Capture non enregistrée",
notFoundMessage: "Cette capture est introuvable. Veuillez la capturer à nouveau.",
mismatchMessage: "Cette capture ne correspond pas à la demande actuelle.",
notSupportedTitle: "Capture non prise en charge",
scanNotSupportedMessage: "Le scan QR se fait depuis le scanner et n'est pas enregistré dans les demandes.",
tryAgain: "Vérifiez votre connexion et réessayez.",
noPhotoCaptured: "Aucune photo n'a été prise.",
signInToAttachPhotos: "Connectez-vous pour joindre des photos.",
couldNotUploadPhoto: "Impossible de télécharger la photo.",
noCommentTextCaptured: "Aucun texte de commentaire n'a été capturé.",
modeNotSupported: "Ce mode de capture n'est pas pris en charge pour les demandes.",
photoAdded: "Photo ajoutée à la demande",
commentAdded: "Commentaire ajouté à la demande",
measurementAdded: "Mesure ajoutée aux commentaires de la demande",
measurementCommentTemplate: "Mesure : {{reading}}",
},
toast: {
approved: "Demande approuvée et demandeur prévenu. Touchez ensuite Créer un travail ou Inspecter pour la planifier.",
declined: "Demande refusée. Le demandeur a été prévenu.",
caseClosed: "Demande clôturée. Le demandeur a été prévenu.",
replyRecorded: "Réponse notée. La demande vous revient pour la suite.",
messageSent: "Question envoyée. La demande attend leur réponse ; vous serez prévenu.",
caseReopened: "Demande rouverte. Elle est de retour dans Travail, sous Besoin de vous.",
},
screenTitle: "Demande",
loadingMessage: "Chargement de la demande...",
notFoundMessage: "Demande introuvable",
notFoundHint: "Cette demande a peut-être été supprimée ou vous n'y avez peut-être pas accès.",
requestFallbackTitle: "Demande",
reopenFailedTitle: "Impossible de rouvrir la demande",
},
requestCaseLinkedWork: {
statusLabel: {
scheduled: "Planifié",
toSchedule: "À planifier",
due: "Échéance",
overdue: "En retard",
inProgress: "En cours",
paused: "En pause",
submitted: "Soumis",
completedAwaitingSignoff: "Terminé – en attente d’approbation",
done: "Terminé",
reworkInProgress: "Reprise en cours",
cancelled: "Annulé",
pending: "En attente",
},
reportStatus: {
sharedReadyForReview: "Partagé – prêt pour examen",
approved: "Approuvé",
changesRequested: "Modifications demandées",
reviewed: "Examiné",
},
provenance: {
youApproved: "Vous avez approuvé ce travail",
approvedByRequester: "Approuvé par le demandeur",
youDeclined: "Vous avez refusé cette proposition — parlez-en dans la conversation",
declinedByRequester: "Refusé par le demandeur",
followUpProposed: "Suivi proposé par l'équipe",
followUpJob: "Intervention de suivi",
addedByTeamNotFromReview: "Ajouté par l'équipe — et non issu de votre avis",
addedByTeam: "Ajouté par l'équipe",
},
repair: {
fallbackLabel: "Réparation {{number}}",
approved: "Approuvé",
declined: "Refusé",
awaitingDecision: "En attente de décision",
jobState: "Intervention : {{status}}",
noJobYet: "Aucune intervention pour l'instant",
},
heading: "Travail lié",
inspectionTitle: "Inspection",
completed: "Terminé",
jobFallbackTitle: "Intervention",
reportTitle: "Rapport d’inspection",
youAcceptedAwaitingTeam: "Vous avez accepté — en attente de confirmation de l'équipe",
acceptedByRequesterVerify: "Accepté par le demandeur — vérifiez pour fermer",
visitConfirmed: "Visite confirmée",
visitConfirmedByRequester: "Visite confirmée par le demandeur",
confirmVisitBelow: "Confirmez la visite ci-dessous",
awaitingRequesterVisitConfirmation: "En attente de confirmation de visite du demandeur",
photoCount_one: "{{count}} photo",
photoCount_other: "{{count}} photos",
approvedRepairsAwaitingJobs_one: "{{count}} réparation approuvée en attente d'intervention",
approvedRepairsAwaitingJobs_other: "{{count}} réparations approuvées en attente d’interventions",
createApprovedJobs_one: "Créer {{count}} intervention approuvée",
createApprovedJobs_other: "Créer {{count}} interventions approuvées",
confirmVisit: "Confirmer la visite",
confirmVisitA11y: "Confirmez que quelqu'un peut être présent pour la visite",
requestDifferentTime: "Demander une heure différente",
requestDifferentTimeA11y: "Demander une heure de visite différente",
reviewCompletionReport: "Examiner le rapport d'achèvement",
reviewAndSignOff: "Examiner et valider",
viewCompletionReport: "Afficher le rapport d'achèvement",
openCompletionReportA11y: "Ouvrir le rapport d'achèvement de l'intervention",
acceptCompletion: "Accepter le travail",
acceptCompletionA11y: "Accepter le travail terminé",
requestRework: "Renvoyer",
requestReworkA11y: "Renvoyer l'intervention pour qu'elle soit corrigée",
createJobsFromRepairsA11y: "Créer des interventions à partir des réparations approuvées",
viewReportResponse: "Afficher la réponse au rapport",
reviewSharedReport: "Examiner le rapport partagé",
viewYourReportResponseA11y: "Afficher la réponse à votre rapport",
reviewSharedReportA11y: "Examiner le rapport partagé",
photoCount_many: "{{count}} photos",
approvedRepairsAwaitingJobs_many: "{{count}} réparations approuvées en attente d’interventions",
createApprovedJobs_many: "Créer {{count}} interventions approuvées",
},
detailRoute: {
notFoundTitle: "Détail du travail",
notFoundMessage: "Élément de travail introuvable",
notFoundHint: "Ouvrez cette intervention ou cette inspection à partir de Travail, Actifs ou d'un lien partagé valide.",
},
kanbanSwimlanes: {
emptyDefault: "Aucun élément dans cette vue.",
unassigned: "Non assigné",
assetColumnHeader: "Actif",
},
queueCardGrid: {
emptyDefault: "Aucun élément dans la file d'attente",
open: "Ouvrir",
start: "Démarrer",
openItemA11y: "Ouvrir {{title}}",
startItemA11y: "Démarrer {{title}}",
},
statusTransitionBar: {
currentA11y: "Statut : {{label}}",
moveToA11y: "Déplacer vers {{label}}",
changeStatusA11y: 'Statut : {{label}}. Changer le statut',
sheetTitle: 'Changer le statut',
},
stall: {
days_one: "{{count}} jour",
days_many: "{{count}} de jours",
days_other: "{{count}} jours",
waitingOnYourApproval: "En attente de votre approbation depuis {{span}}.",
waitingOnYourValidation: "En attente de votre validation depuis {{span}}.",
noResponseFrom: "Aucune réponse de {{name}} depuis {{span}}.",
notValidated: "{{name}} n’a pas validé ceci depuis {{span}}.",
notApproved: "{{name}} n’a pas approuvé ceci depuis {{span}}.",
theRecipient: "le destinataire",
theRequester: "le demandeur",
theApprover: "L’approbateur",
theValidator: "Le validateur",
approveOnTheirBehalf: "Approuver en son nom",
validateInTheirPlace: "Valider à sa place",
hintDecide: "En tant qu’équipe de l’actif, vous pouvez décider à sa place. Les deux choix sont enregistrés comme effectués en son nom.",
hintValidate: "En tant qu’équipe de l’actif, vous pouvez valider ceci à sa place.",
hintSignOff: "En tant qu’équipe de l’actif, vous pouvez approuver ceci à sa place.",
saving: "Enregistrement…",
},
triageInbox: {
titleDefault: "Nouvelles",
emptyLabelDefault: "Aucune nouvelle demande.",
cleared: "Toutes les demandes sont décidées",
approve: "Approuver",
reject: "Refuser",
},
nameTypeFilter: {
typeDefault: "Type",
pickerTitleDefault: "Filtrer par type",
any: "tous",
typeA11y: "{{label}} : {{value}}",
},
sortMenu: {
triggerA11y: "Trier : {{label}}",
sortBy: "Trier par",
},
viewToggle: {
cards: "Cartes",
table: "Tableau",
kanban: "Kanban",
calendar: "Calendrier",
},
attentionReasons: {
OVERDUE: "En retard",
AWAITING_YOU: "En attente de votre action",
AWAITING_OTHER: "En attente d’une autre personne",
UNSCHEDULED: "Pas encore planifié",
DUE_SOON: "Échéance proche",
URGENT_PRIORITY: "Marqué urgent",
APPROVAL_REQUIRED: "En attente de votre approbation",
REVIEW_REQUIRED: "En attente de votre examen",
REPAIR_JOBS_REQUIRED: "Les réparations approuvées nécessitent des interventions",
STALLED: "Sans réponse — vous pouvez intervenir",
},
list: {
  board: {
    moveItemA11y: "Déplacer {{title}}",
    moveSelectedA11y: "Déplacer {{n}} vers {{column}}",
    bulkSummaryBlocked: "Déplacer {{n}} vers {{column}}. {{blocked}} ne peuvent pas être déplacés depuis leur état actuel.",
    bulkSummary: "Déplacer {{n}} vers {{column}}.",
    requestMoveReason: "Une demande avance quand on l’approuve, la refuse ou la convertit : ouvrez-la pour décider.",
    inspectionMoveReason: "Une inspection avance quand on la réalise : ouvrez-la pour continuer.",
    moveNotAllowedTitle: "Déplacement impossible",
    moveNotAllowed: "Ce déplacement n’est pas autorisé.",
    cannotMoveStraight: "Un travail « {{from}} » ne peut pas passer directement à « {{to}} ».",
  },
  selectedA11y: "Sélectionné",
  emptyState: {
    showMeHow: "Montrez-moi comment",
    scheduleInspection: "Planifier une inspection",
    none: "Pas encore de travail ici. Planifiez une inspection pour commencer.",
    showAll: "Afficher tout le travail",
    review: "Rien n’attend de revue.",
    due_soon: "Rien n’arrive à échéance bientôt.",
    mine: "Rien ne vous est assigné pour le moment.",
    needs_attention: "Rien ne nécessite votre attention pour le moment.",
    clearFilters: "Effacer les filtres",
    filtered: "Rien ne correspond à vos choix dans Affiner.",
  },
simpleStatus: {
  todo: "À faire",
  in_progress: "En cours",
  waiting: "En attente",
  done: "Terminé",
  waitingFor: "En attente de {{name}}",
  waitingOn: "En attente · {{who}}",
  waitingForAssignee: "En attente de l'assigné",
  waitingForRequester: "En attente du demandeur",
  waitingForReview: "En attente de revue",
  waitingForQuotes: "En attente de devis",
  waitingForApproval: "En attente d'approbation",
},
quickView: {
needs_attention: "Besoin de vous",
mine: "À moi",
due_soon: "Échéance proche",
review: "À valider",
all: "Tout",
},
reviewScope: {
  yours: "Les vôtres",
  everyone: "Tout le monde",
},
view: {
  calendarShort: "Calendrier",
  listShort: "Liste",
  title: "Affichage",
cards: "Vue liste",
calendar: "Vue calendrier",
},
type: {
request: "Demandes",
inspection: "Inspections",
job: "Interventions",
},
sort: {
urgency: "Urgence",
due: "Date d'échéance",
updated: "Mis à jour récemment",
priority: "Priorité",
created: "Plus récent",
},
group: {
asset: "Actif",
site: "Site",
assignee: "Assigné à",
status: "Statut",
type: "Type",
none: "Aucun",
},
groupUrgent_one: "{{count}} urgent",
groupUrgent_many: "{{count}} urgents",
groupUrgent_other: "{{count}} urgents",
groupByLabel: "Grouper : {{axis}}",
groupByTitle: "Grouper le travail par",
collapseAll: "Tout replier",
expandAll: "Tout déplier",
collapseGroup: "Replier {{name}} ({{count}})",
expandGroup: "Déplier {{name}} ({{count}})",
groupOverdue: "En retard : {{count}}",
groupNeedsYou: "Pour vous : {{count}}",
groupDueSoon: "Échéance proche : {{count}}",
groupNew: "Nouveau : {{count}}",
groupTypeDocument: "Justificatifs",
groupNone: { asset: "Sans actif", site: "Sans site", assignee: "Non attribué" },
newLane: { title: "Nouveau depuis votre dernière visite", more: "Afficher {{count}} de plus", fewer: "Afficher moins" },
openAsset: "Ouvrir {{name}}",
report: {
all: "Tous",
has_report: "Avec rapport",
awaiting_review: "En attente de validation",
signed_off: "Validé",
},
refine: {
button: "Affiner",
output: "Résultat",
type: "Type",
asset: "Actif",
site: "Site",
assignee: "Assigné à",
unassigned: "Non assigné",
urgency: "Urgence",
status: "Statut",
review: "Validation",
reviewToggle: "Nécessite ma validation",
time: "Période",
renewals: "Renouvellements",
renewalsToggle: "Afficher les renouvellements",
sortBy: "Trier par",
anyAsset: "Tous les actifs",
unnamedSite: "Site sans nom",
unnamedAssignee: "Personne sans nom",
anySite: "Tous les sites",
anyone: "N'importe qui",
assigneeFacetTeam: "Équipe",
assigneeFacetExternal: "Externe",
selectedCount_one: "{{count}} sélectionné",
selectedCount_many: "{{count}} sélectionnés",
selectedCount_other: "{{count}} sélectionnés",
searchPlaceholder: "Rechercher…",
searchAssetPlaceholder: "Rechercher des actifs…",
removeAsset: "Retirer {{name}}",
searchSitePlaceholder: "Rechercher des sites…",
searchAssigneePlaceholder: "Rechercher des personnes…",
noMatches: "Aucun résultat.",
clear: "Effacer",
clearSelection: "Effacer la sélection",
done: "Terminé",
},
timePreset: {
overdue: "En retard",
today: "Aujourd'hui",
next_7: "7 prochains jours",
},
urgencyBand: {
critical: "Critique",
high: "Élevée",
medium: "Moyenne",
low: "Faible",
},
status: {
triage: "Nouvelles",
scheduled: "Planifié",
in_progress: "En cours",
awaiting_review: "En attente de validation",
done: "Terminé",
cancelled: "Annulé",
},
kanbanEmpty: {
triage: "Aucune nouvelle demande.",
scheduled: "Rien de planifié.",
in_progress: "Rien en cours.",
awaiting_review: "Rien en attente de validation.",
done: "Rien de terminé pour l'instant.",
cancelled: "Rien d'annulé.",
board: "Aucun travail en cours pour cette vue.",
},
due: {
  inDays: "Échéance dans {{n}} j",
  overdueDays: "{{n}} j de retard",
overdue: "En retard",
today: "Échéance aujourd'hui",
tomorrow: "Échéance demain",
onDate: "Échéance le {{date}}",
},
badge: {
urgency: {
critical: "Urgent",
high: "Élevée",
},
rework: "Renvoyé",
quotesDeclined: "Tous refusés",
quotesWaiting: "En attente de devis",
awaitingRequester: "En attente du demandeur",
subJobsDone: "{{done}} sur {{total}} sous-travaux faits",
subJobNeedsYou: "Un sous-travail vous attend",
partOf: "Partie de {{title}}",
partOfAJob: "Partie d'un travail plus grand",
confirmVisit: "Confirmer la visite",
visitUnconfirmed: "Visite non confirmée",
acceptancePending: "Accepter ou refuser",
awaitingAcceptance: "En attente d'acceptation",
awaitingVerification: "En attente de vérification",
quoteInvited: "Invitation à devis",
attention: {
overdue: "En retard",
awaiting_you: "En attente de vous",
stalled: "Bloqué",
unscheduled: "Non planifié",
expiring_soon: "Échéance proche",
},
column: {
triage: "Ouvert",
scheduled: "Planifié",
in_progress: "En cours",
awaiting_review: "En attente de validation",
},
review: {
awaiting_your_approval: "À approuver",
you_must_review: "À valider",
awaiting_recipient: "En attente de réponse",
changes_requested: "Modifications demandées",
},
report: {
awaiting_repairs_conversion: "Réparations approuvées",
pending_signoff: "Rapport prêt",
signed_off: "Validé",
},
done: {
completed: "Clôturé",
verified: "Validé",
rejected: "Refusé",
cancelled: "Annulé",
superseded: "Remplacé",
skipped: "Ignoré",
},
},
empty: "Rien ici pour l'instant.",
emptyReports: "Pas encore de rapport ici. Un rapport apparaît dès qu'une inspection ou une intervention en a un.",
previewEmpty: "Sélectionnez une intervention ou une demande pour la gérer ici.",
loadError: "Certains éléments n'ont pas pu être chargés ({{sources}}).",
retry: "Réessayer",
loadingA11y: "Chargement du travail",
preview: {
kind: {
job: "Intervention",
request: "Demande",
inspection: "Inspection",
schedule: "Inspection",
document: "Document",
},
asset: "Actif",
status: "Statut",
due: "Échéance",
noDue: "Aucune échéance",
assigned: "Assigné",
unassigned: "Non assigné",
site: "Site",
report: "Rapport",
reportAvailable: "Disponible",
reportNone: "Non disponible",
openFull: "Ouvrir la fiche complète",
openFullKind: "Ouvrir {{kind}}",
pin: "Épingler le panneau",
unpin: "Désépingler le panneau",
collapse: "Réduire le panneau",
},
},
aiNextSteps: {
summaryReady: "{{ready}} sur {{total}} prêtes à exécuter",
createdMore: "+{{count}} de plus",
openCreatedA11y: "Ouvrir {{label}}",
recordKind: {
job: "Voir l'intervention",
inspection_schedule: "Voir l'inspection planifiée",
request: "Voir la demande",
template: "Voir la check-list",
},
title: "Prochaines étapes suggérées",
planning: "Calcul des meilleures prochaines étapes…",
running: "Exécution des étapes confirmées…",
empty: "Rien à faire ici pour le moment.",
doAll: "Tout faire ({{total}})",
doStep: "Faire ceci",
doStepA11y: "Exécuter cette étape : {{step}}",
retry: "Réessayer",
dismiss: "Masquer",
errorFallback: "Impossible de suggérer des prochaines étapes.",
blocked: {
advisory: "Conseil uniquement — rien à exécuter automatiquement.",
missingDetails: "Il manque quelques informations avant de pouvoir l’exécuter.",
},
outcome: {
executed: "Terminé",
failed: "Cette étape n’a pas abouti.",
},
results: {
allDone: "Toutes les étapes confirmées sont terminées ({{total}}).",
partial: "{{executed}} terminées, {{failed}} en échec.",
},
confirm: {
title: "Confirmer ce qui va se passer",
intro: "Ceci va s’exécuter maintenant et modifier vos données ({{total}}) :",
noDetail: "Aucun autre détail disponible.",
run: "Exécuter maintenant",
cancel: "Annuler",
},
},
workflow: {
actions: {
requestedReview: "Validation demandée",
approvedRepairs: "Réparations approuvées",
assignedWork: "Travail assigné",
scheduleProposed: "Planification proposée",
workStarted: "Travail commencé",
workPaused: "Travail suspendu",
workResumed: "Travail repris",
completionSubmitted: "Achèvement soumis",
reworkRequested: "Reprise demandée",
workApproved: "Travail approuvé",
jobAccepted: "Intervention acceptée",
jobDeclined: "Intervention refusée",
quoteRequestSent: "Demande de devis envoyée",
quoteSubmitted: "Devis soumis",
quoteAccepted: "Devis accepté",
quoteRejected: "Devis refusé",
contractorAwarded: "Prestataire retenu",
},
},
search: {
title: "Rechercher dans Travail",
placeholder: "Rechercher des inspections, interventions, demandes ou actifs",
triggerA11y: "Rechercher dans Travail",
triggerHint: "Rechercher des inspections, interventions, demandes ou actifs",
inputA11y: "Rechercher des inspections, interventions, demandes ou actifs",
closeA11y: "Fermer la recherche Travail",
clearA11y: "Effacer la recherche Travail",
scope: {
all: "Tout",
inspections: "Inspections",
jobs: "Interventions",
requests: "Demandes",
},
scopeActive: "{{type}} uniquement ✕",
groups: {
inspection: "Inspections",
job: "Interventions",
request: "Demandes",
asset: "Actifs",
contact: "Contacts",
},
refine: "Affiner",
refineCount: "Affiner {{count}}",
refineA11y_one: "Affiner la recherche Travail, {{count}} catégorie de filtres active",
refineA11y_many: "Affiner la recherche Travail, {{count}} catégories de filtres actives",
refineA11y_other: "Affiner la recherche Travail, {{count}} catégories de filtres actives",
clearFilters: "Tout effacer",
filters: {
state: "État",
scope: "Portée",
all: "Tout",
open: "Ouvert",
completed: "Terminé",
mine: "Assigné à moi",
team: "Mon équipe",
needsAttention: "Besoin d'attention",
},
minimumTitle: "Rechercher dans tout Travail",
recentsTitle: "Récent",
recentsClear: "Effacer",
pinA11y: "Épingler pour garder en haut",
unpinA11y: "Désépingler",
minimumBody: "Saisissez au moins deux caractères pour rechercher parmi les inspections, interventions, demandes et actifs autorisés.",
loading: "Recherche dans Travail…",
errorTitle: "La recherche est indisponible",
errorBody: "Impossible de rechercher dans Travail. Vérifiez votre connexion et réessayez.",
noResultsTitle: "Aucun élément correspondant",
noResultsBody: "Essayez un autre titre, référence, actif, lieu ou assigné.",
viewAll: "Tout afficher",
viewAllA11y: "Afficher tous les résultats {{type}}",
result: {
type: {
inspection: "Inspection",
job: "Intervention",
request: "Demande",
asset: "Actif",
contact: "Contact",
},
statusA11y: "Statut {{status}}",
dateA11y: "Date {{date}}",
assigneeA11y: "Assigné à {{name}}",
},
},
hub: {
title: "Travail",
impactTitle: "Certains actifs seulement",
impactBody_one: "Cette liste n’affiche que le travail de {{count}} actif.",
impactBody_other: "Cette liste n’affiche que le travail de {{count}} actifs.",
impactClear: "Tout afficher",
impactClearA11y: "Afficher le travail de tous les actifs",
tablistLabel: "Filtrer Travail par type : Inspections, Interventions ou Demandes",
emptyViewAll: "Tout afficher",
segments: {
queue: "Ma file",
inspections: "Inspections",
jobs: "Interventions",
approvals: "Approbations",
requests: "Demandes",
templates: "Check-lists d'inspection",
},
hints: {
queue: "Afficher le travail priorisé (inspections, travaux et éléments en attente de décision)",
inspections: "Afficher les inspections, revues et planifications",
jobs: "Interventions et charge de travail",
approvals: "Examiner les demandes entrantes et le travail terminé en attente de décision",
requests: "Trier les demandes entrantes ; approuver, planifier ou convertir en inspections ou en interventions",
templates: "Listes de contrôle d'inspection réutilisables",
inspectionsFilter: "Filtrer Travail sur les inspections, revues et planifications. Sélectionnez à nouveau pour afficher tout ce qui vous attend.",
jobsFilter: "Filtrer Travail sur les interventions. Sélectionnez à nouveau pour afficher tout ce qui vous attend.",
requestsFilter: "Filtrer Travail sur les demandes entrantes. Sélectionnez à nouveau pour afficher tout ce qui vous attend.",
},
secondaryLabel: "Secondaire",
workflowLibrary: "Check-lists",
workflowLibraryShort: "Check-lists",
workflowLibraryHint: "Listes de contrôle d'inspection réutilisables",
workflowLibraryA11y: "Ouvrir les check-lists",
workflowLibraryBack: "Retour à Travail",
workflowLibraryBackHint: "Quitter les check-lists",
workflowLibraryBackA11y: "Revenir à la file de travail",
secondaryToolsTitle: "Rapports opérationnels",
secondaryToolsSummary: "Rapports et analyses.",
secondaryToolsMeta: "1 outil secondaire",
status: {
attention: "Besoin d'attention",
inspections: "Inspections ouvertes",
jobs: "Interventions ouvertes",
approvals: "Approbations",
requests: "Demandes",
},
nextAction: {
eyebrow: "Recommandé ensuite",
reviewApprovals: "Examiner les approbations",
reviewApprovalsMeta: "Décidez quelles demandes entrantes et travaux terminés avancent.",
openQueue: "Afficher tout ce qui a besoin de vous",
openQueueMeta: "En retard, dus aujourd'hui et bloqués.",
continueInspections: "Poursuivre les inspections",
continueInspectionsMeta: "Planifiées, en cours et terminées.",
continueJobs: "Poursuivre les interventions",
continueJobsMeta: "Responsables, blocages, dates, statut.",
backToQueue: "Retour à Travail",
backToQueueMeta: "Revenir à tout ce qui a besoin de vous.",
openWorkflows: "Ouvrir les check-lists",
openWorkflowsMeta: "Créer ou réutiliser des listes de contrôle d'inspection.",
},
impactBody_many: "Cette liste n’affiche que le travail de {{count}} actifs.",
},
queue: {
mobileFilter: {
all: "Tout",
overdue: "En retard",
today: "Aujourd'hui",
approvals: "Approbations",
a11y: "Filtrer la file : {{label}}",
},
focus: {
showing: "Affichage : {{label}} · {{count}}",
inProgress: "Travail en cours",
attention: "À traiter",
clear: "Effacer",
clearA11y: "Effacer le filtre et afficher toute la file",
showAll: "Tout afficher",
},
emptyFocused: "Rien ici : {{label}}.",
refineGroupBy: "GROUPER PAR",
groupBy: {
asset: "Par actif",
status: "Par statut",
},
table: {
type: "Type",
},
calendar: {
today: "Aujourd'hui",
todayA11y: "Aller à aujourd'hui",
prevMonthA11y: "Mois précédent",
nextMonthA11y: "Mois suivant",
moreCount: "+{{count}} de plus",
emptyDay: "Rien de prévu ce jour-là",
dayA11y: "{{date}} — {{count}} prévu(s) : {{summary}}",
dayEmptyA11y: "{{date}} — rien de prévu",
summaryAndMore: "{{titles}} et {{count}} de plus",
openItemA11y: "Ouvrir {{type}} : {{title}}",
unscheduledTitle: "Non planifié · {{count}}",
unscheduledHint: "Pas encore de date. Ouvrez-en un pour lui donner une date.",
scheduleWork: "Planifier du travail",
scheduleSheetTitle: "Que voulez-vous planifier ?",
scheduleInspection: "Planifier une inspection",
scheduleJob: "Planifier une intervention",
filters: {
all: "Tout",
jobs: "Interventions",
inspections: "Inspections",
requests: "Demandes",
renewals: "Documents",
},
prevRangeA11y: "Deux semaines précédentes",
nextRangeA11y: "Deux semaines suivantes",
upcoming: "À venir",
modeMonth: "Mois",
modeWeek: "Semaine",
modeMonthA11y: "Afficher la grille du mois",
modeWeekA11y: "Afficher la semaine par heure",
prevWeekA11y: "Semaine précédente",
nextWeekA11y: "Semaine suivante",
allDay: "Journée entière",
weekItemA11y: "{{type}} à {{time}} : {{title}}",
},
itemKinds: {
job: "Intervention",
inspection: "Inspection",
request: "Demande",
document: "Document",
condition: "État",
activity: "Activité",
quick_action: "Action rapide",
},
empty: "La file est vide.",
emptyLine: "Rien dans votre file pour ce périmètre.",
emptyBrowse: "Ouvrir Inspections",
emptyBrowseA11y: "Ouvrir le registre des inspections",
searchPlaceholder: "Rechercher par actif, ID, responsable",
ungroupedSite: "Autre",
hintFullLists: "Listes complètes dans Inspections et Interventions.",
context: {
followUpTitle: "Suivi",
toolsTitle: "Check-lists",
reportIssue: "Déclarer un incident",
flagProblem: "Signaler une anomalie",
requestFix: "Demander une intervention",
escalate: "Faire remonter",
reusePrevious: "Réutiliser un existant",
moreFollowUps: "Plus",
moreFollowUpsSheetTitle: "Enregistrer un suivi ou un workflow",
},
sections: {
queueTitle: "File",
overdue: "En retard · {{count}}",
dueToday: "Aujourd'hui · {{count}}",
certificateActions: "Certificats arrivant à échéance · {{count}}",
scheduledInspections: "Inspections planifiées · {{count}}",
inProgressJobs: "Interventions en cours · {{count}}",
needsAttention: "À traiter · {{count}}",
reportReviews: "Relectures de rapport",
},
},
assetCollaboration: {
  respondBy: {
    days: "{{count}} j",
    hours: "{{count}} h",
    minutes: "{{count}} min",
    overdue: "En retard de {{window}}",
    dueIn: "Échéance dans {{window}}",
  },
  requestType: {
    job: "Intervention",
    inspection: "Inspection",
    help: "Aide",
  },
  requestPriority: {
    urgent: "Urgente",
    high: "Élevée",
    medium: "Moyenne",
    low: "Faible",
  },
  activityLabels: {
    lifecycleRecorded: "Enregistré",
    lifecycleBulk: "Modification groupée",
    team: "L'équipe",
    shareRole: {
      requester: "Demandeur",
      viewer: "Lecteur",
    },
    shareStatus: {
      revoked: "Révoqué",
      declined: "Refusé",
      active: "Actif",
      pending: "En attente d'acceptation",
    },
    sharedWithContact: "Partagé avec un contact",
    sharedWith: "Partagé avec {{name}}",
    documentStatus: {
      no_expiry: "Sans date d'expiration",
      expired: "Expiré",
      expiring_soon: "Expire bientôt",
      valid: "Valide",
    },
    connectedState: {
      planned: "Enregistré",
      outstanding: "À traiter",
      completed: "Résolu",
    },
    connectedSource: "Source connectée",
    inspector: "Inspecteur",
    unassigned: "Non attribué",
    scheduledInspection: "Inspection planifiée",
    type: {
      lifecycle: "Cycle de vie",
      location: "Emplacement",
      access: "Accès",
      connected: "Système connecté",
      document: "Document",
      job: "Intervention",
      inspection: "Inspection",
    },
  },
  breadcrumbRequests: "Demandes",
  evidenceFromRequest: "Photos de la demande",
  conversation: {
    empty: "Aucun message pour l’instant. Envoyez-en un ci-dessous — {{who}} le verra et répondra ici.",
    noneExchanged: "Aucun message n’a été échangé sur cette demande.",
  },
  closedBanner: {
    declinedRequester: "Cette demande a été clôturée sans suite.",
    declinedOp: "Cette demande a été refusée ou retirée.",
    doneRequester: "Tout est terminé — vous avez accepté le travail. Plus rien à faire.",
    doneOp: "Le travail est fait et validé. Cette demande est terminée.",
    teamClosed: "L’équipe a clôturé cette demande.",
    closedByTeam: "Votre équipe a clôturé cette demande. Touchez Rouvrir s’il reste à faire.",
    closedByYou: "Vous avez clôturé cette demande. Touchez Rouvrir s’il reste à faire.",
    titleNotProceeding: "Clôturée · Abandonnée",
    titleDone: "Clôturée · Terminée",
  },
  tracker: {
    next: "Ensuite :",
    active: "Ouverte depuis {{age}}",
    closedTook: "Clôturée · en {{age}}",
    closed: "Clôturée",
    progressA11yNow: "Avancement : {{done}} étapes sur {{total}} terminées, étape actuelle {{stage}}",
    progressA11y: "Avancement : {{done}} étapes sur {{total}} terminées",
  },
  row: {
    noAccountA11y: "signalée sans compte",
    noAccount: "Sans compte",
    contact: "Contact",
    unassigned: "Non attribuée",
    team: "Équipe",
    assigned: "Attribuée",
    preferred: "Souhaitée",
    scheduled: "Planifiée",
  },
  showAll_other: "Tout afficher ({{count}})",
  showAll_many: "Tout afficher ({{count}})",
  showAll_one: "Tout afficher ({{count}})",
  showFewer: "Afficher moins",
  messages: {
    newReplies_other: "{{count}} nouvelles réponses de l’équipe",
    newReplies_many: "{{count}} nouvelles réponses de l’équipe",
    newReplies_one: "{{count}} nouvelle réponse de l’équipe",
    open: "Écrire à l’équipe",
    hide: "Masquer les messages",
  },
  period: {
    pm: "Après-midi",
    am: "Matin",
  },
  withdraw: {
    confirm: "Retirer",
    keep: "La garder",
    body: "Cela annule la demande et toute visite prévue, et prévient l’équipe.",
    title: "Retirer cette demande ?",
    button: "Retirer la demande",
  },
  badge: {
    request: "Demande",
    job: "Intervention",
    inspection: "Inspection",
  },
  showDetailsA11y: "{{title}}. Afficher les détails",
  hideDetailsA11y: "{{title}}. Masquer les détails",
  collapseHide: "Masquer",
  expandShow: "Afficher",
  emptyAssetRequester: "Vous n’avez encore rien signalé sur cet équipement.",
  sectionPendingRequester: "Envoyées — l’équipe les examine",
  summary: {
    declined_other: "{{count}} refusées",
    declined_many: "{{count}} refusées",
    declined_one: "{{count}} refusée",
    accepted_other: "{{count}} acceptées",
    accepted_many: "{{count}} acceptées",
    accepted_one: "{{count}} acceptée",
    planned_other: "{{count}} planifiées",
    planned_many: "{{count}} planifiées",
    planned_one: "{{count}} planifiée",
    inProgress_other: "{{count}} en cours",
    inProgress_many: "{{count}} en cours",
    inProgress_one: "{{count}} en cours",
    withTeam_other: "{{count}} chez l’équipe",
    withTeam_many: "{{count}} chez l’équipe",
    withTeam_one: "{{count}} chez l’équipe",
    needsReply_other: "{{count}} attendent votre réponse",
    needsReply_many: "{{count}} attendent votre réponse",
    needsReply_one: "{{count}} attend votre réponse",
    toLookAt_other: "{{count}} à examiner",
    toLookAt_many: "{{count}} à examiner",
    toLookAt_one: "{{count}} à examiner",
  },
  progress: {
    reports_other: "{{count}} rapports",
    reports_many: "{{count}} rapports",
    reports_one: "{{count}} rapport",
    inspections_other: "{{count}} inspections",
    inspections_many: "{{count}} inspections",
    inspections_one: "{{count}} inspection",
    jobs_other: "{{count}} interventions",
    jobs_many: "{{count}} interventions",
    jobs_one: "{{count}} intervention",
  },
  sort: {
    updated: "Mises à jour récemment",
    oldest: "Plus anciennes",
    newest: "Plus récentes",
  },
  displayStatus: {
    requester: {
      planned: "Planifiée",
      accepted: "Acceptée",
      needsReview: "Attend votre avis",
      declined: "Refusée",
      closed: "Clôturée",
      waiting: "Attend votre réponse",
      active: "En cours",
      triaged: "Approuvée",
      new: "Envoyée",
    },
    operator: {
      declined: "Refusée",
      closed: "Clôturée",
      waiting: "En attente du demandeur",
      active: "En cours",
      triaged: "Approuvée",
      new: "Nouvelle",
    },
  },
  issueReportedConfirmInspection: "Problème enregistré. Choisissez la liste et un horaire pour réserver l’inspection.",
  issueReportedConfirmJob: "Problème enregistré. Vérifiez l'intervention ci-dessous, puis créez-la.",
  updateFailedTitle: "La demande n’a pas été mise à jour",
  visitProposed: "Horaire proposé. Le demandeur doit le confirmer.",
  requester: {
    contactMissing: "Impossible de relier votre compte à cet équipement. Demandez à la personne qui l’a partagé de le repartager.",
    assetMissing: "Impossible de trouver cet équipement. Rouvrez le lien reçu.",
    submitFailedTitle: "Votre signalement n’a pas été envoyé",
    calendarTitle: "Inspection : {{name}}",
    reworkReason: "Le demandeur a demandé que le travail soit refait.",
    tryAgain: "Vérifiez votre connexion et réessayez.",
    declineShareFailed: "Non refusé",
    acceptShareFailed: "Non accepté",
    withdrawFailed: "La demande n’a pas été retirée",
    sendFailed: "Non envoyé",
    confirmFailed: "Non confirmé",
    reviewFailed: "Votre réponse n’a pas été enregistrée",
    rescheduleFailed: "Votre nouvel horaire n’a pas été envoyé",
    confirmVisitFailed: "La visite n’a pas été confirmée",
    reportSent: "Signalement envoyé. L’équipe va l’examiner ; les nouvelles apparaissent ici et vous êtes prévenu.",
    withdrawn: "Demande retirée. L’équipe a été prévenue.",
    preferredTimeSent: "Envoyé. L’équipe examinera l’horaire souhaité et vous répondra.",
    reworkRequested: "Renvoyé à l’équipe. Elle a votre note et va s’en occuper.",
    completionAccepted: "Merci, vous avez accepté le travail. L’équipe va clôturer la demande.",
    rescheduleSent: "Autre horaire demandé. L’équipe en proposera un nouveau.",
    visitConfirmed: "Visite confirmée. L’équipe a été prévenue.",
  },
  journey: {
    naReviewReport: "Consultez le rapport et acceptez le travail",
    naWaitingReviewOp: "En attente de l’avis du demandeur",
    naTeamCloses: "L’équipe confirme et clôture le travail",
    naVerify: "Validez le travail terminé",
    naWorkUnderway: "Le travail est en cours",
    naWillSchedule: "L’équipe va planifier le travail",
    naVisitAsPlanned: "L’équipe viendra comme prévu",
    naConfirmVisit: "Confirmez que quelqu’un sera présent pour la visite",
    naCarryOut: "Réalisez le travail",
    naScheduleJob: "Planifiez et démarrez l'intervention",
    naHelpOp: "Répondez au demandeur ou créez une intervention",
    naStartInspection: "Démarrez l’inspection",
    naTeamArranging: "L’équipe organise le travail",
    naPlanWork: "Planifiez le travail",
    naCreateJob: "Créez l'intervention",
    naScheduleInspection: "Planifiez ou démarrez l’inspection",
    naTeamReviewing: "L’équipe examine votre demande",
    naTriage: "Approuvez, refusez ou posez une question",
    naWaitingOnRequester: "En attente du demandeur",
    naReplyToTeam: "Répondre à l’équipe",
    detailTeamNote: "Note de l’équipe : {{notes}}",
    detailReason: "Motif : {{notes}}",
    slNewRequestOp: "Nouvelle demande.",
    slAllDone: "Tout est terminé.",
    slCompletedOp: "Terminé.",
    slReadyForReview: "Prêt pour votre avis.",
    slWaitingReviewOp: "En attente de l’avis du demandeur.",
    slAccepted: "Vous avez accepté le travail — l’équipe confirme et clôture.",
    slAcceptedOp: "Accepté par le demandeur — validez et clôturez.",
    slWorkUnderway: "Le travail est en cours.",
    slWorkUnderwayOp: "Travail en cours.",
    slJobCreated: "Une intervention a été créée.",
    slJobCreatedOp: "Intervention créée — pas encore planifiée.",
    slVisitPlanned: "Visite prévue le {{when}}.",
    slJobPlannedOp: "Intervention prévue le {{when}}.",
    slHelp: "L’équipe s’en occupe.",
    slHelpOp: "Approuvée — répondez ou créez une intervention.",
    slInspectionUnderway: "Une inspection est en cours.",
    slInspectionUnderwayOp: "Inspection en cours.",
    slInspectionScheduled: "Inspection planifiée le {{when}}.",
    slInspectionBookedOp: "Inspection prévue le {{when}}.",
    slApproved: "Approuvée — l’équipe organise le travail.",
    slApprovedOp: "Approuvée — organisez le travail.",
    slSubmitted: "Envoyée.",
    slNewOp: "Nouvelle — examinez cette demande.",
    slWaitingOnRequester: "En attente d’informations du demandeur.",
    slWaitingOnYou: "L’équipe a besoin de quelques informations de votre part.",
    slDeclined: "Cette demande a été refusée.",
    slDeclinedOp: "Refusée.",
    stDone: "Terminé",
    stClose: "Clôturer",
    stYourReview: "Votre avis",
    stReport: "Rapport",
    stSignOff: "Validation",
    stAnswered: "Répondu",
    stAnswer: "Répondre",
    stInProgress: "En cours",
    stWork: "Travaux",
    stInspecting: "Inspection en cours",
    stInspect: "Inspecter",
    stPlanned: "Planifiée",
    stSchedule: "Planifier",
    stReviewed: "Examinée",
    stTriage: "Examen",
    stRaised: "Envoyée",
    stReceived: "Reçue",
  },
  requestConvert: {
    choose: "Choisir la suite",
    inspectMeta: "Choisissez la liste de contrôle et un horaire. L’inspection est réservée et reste liée à la demande.",
    jobMeta: "Vérifiez qui s’en charge, pour quand et les consignes, puis créez l'intervention.",
    inspectInstead: "Inspecter plutôt",
    inspect: "Inspecter",
    jobInstead: "Créer plutôt une intervention",
    job: "Créer une intervention",
    subtitle: "Les détails de la demande sont déjà remplis. Vous confirmez seulement qui s’en charge et quand.",
    title: "Que faut-il faire ensuite ?",
  },
  requestFulfilment: {
    unclear: "Le problème n’est pas clair : une inspection montrera le travail nécessaire.",
    urgentUnclear: "C’est urgent mais flou : envoyez quelqu’un maintenant qui vérifiera sur place.",
    readsAsCheck: "Cela ressemble à un contrôle d’état ou de sécurité : inspectez d’abord.",
    describesFault: "Il décrit une chose à réparer : une intervention est la voie la plus rapide.",
    askedForJob: "Une intervention a été demandée.",
    askedForInspection: "Une inspection a été demandée.",
    assessFirst: "Vérifiez d’abord, pour savoir quel travail est nécessaire.",
  },
tabLabel: "Suivis",
tabTitle: "Suivis et tri",
tabIntro: "Ajoutez des suivis et traitez les demandes de contacts.",
openApprovalsQueue: "Voir toutes les demandes dans Travail",
sectionCardTitle: "Demandes sur cet actif",
sectionCardSub: "Signalez un problème ou voyez toutes les demandes dans Travail.",
sectionCardSubRequester: "Signalez un problème et suivez ce qu'il devient.",
newRequest: "Nouvelle demande",
composeItemTitle: "Élément de liste de contrôle d'inspection",
composeItemDescription: "Élément de liste de contrôle référencé : {{itemId}}",
activityFollowUpLabel: "Suivi",
activityAssetLabel: "Actif",
activityAssetCreatedTitle: "Actif ajouté",
activityAssetCreatedStatus: "Créé",
activityAssistantChangeTitle: "Modifié via l'assistant",
activityAssistantUndoneTitle: "Modification de l'assistant annulée",
activityAssistantStatus: "Confirmé dans l'assistant",
activitySiteLabel: "Site",
missingAssetForCompose: "Impossible de trouver cet actif.",
missingLinkedContactForCompose: "Impossible d’enregistrer ce problème à votre nom. Déconnectez-vous et reconnectez-vous, puis réessayez.",
operatorLinkedContactNoAccount: "Votre profil n’est pas encore rattaché à un compte d’espace de travail. Déconnectez-vous puis reconnectez-vous, ou contactez le support.",
operatorLinkedContactAutoFailed: "Impossible d’enregistrer ce problème à votre nom. Réessayez dans un instant ; si cela continue, déconnectez-vous puis reconnectez-vous.",
composeSubmitErrorTitle: "Envoi impossible",
issueReported: "Problème enregistré. Approuvez-le, ou touchez Créer une intervention ou Inspecter pour planifier.",
composeSubmitErrorBody: "Veuillez réessayer.",
composeOpenErrorTitle: "Ouverture impossible",
sectionPending: "Nouvelles",
sectionAwaitingCustomer: "Attend votre réponse",
sectionAwaitingCustomerInternal: "En attente du demandeur",
sectionActive: "Approuvées, planifiées ou en cours",
sectionClosed: "Clôturées",
sectionRejected: "Refusées",
emptyAsset: "Rien n’a encore été signalé sur cet équipement. Touchez Nouvelle demande pour signaler un problème.",
loadingFollowUps: "Chargement des suivis…",
emptySection: "Rien dans ce groupe.",
actionApprove: "Approuver",
actionReject: "Refuser",
actionSchedule: "Planifier",
actionConvert: "Choisir le type de travail",
metaContactFallback: "Contact",
metaNoPriority: "Aucune priorité",
metaNoDate: "Aucun créneau souhaité",
outcomeTypeJob: "Intervention suivie",
outcomeTypeInspection: "Inspection planifiée",
},
followUpDetail: {
managerActionsTitle: "Actions du responsable",
managerApprove: "Approuver",
managerReject: "Refuser",
managerSchedule: "Planifier",
managerConvertJob: "Convertir en intervention",
managerConvertInspection: "Convertir en inspection",
summaryAssetHeadline: "Actif",
summaryRequesterHeadline: "Demandeur",
emptyLoadingTitle: "Chargement",
emptyLoadingBody: "Récupération du dernier résumé et de l'historique.",
emptySelectTitle: "Sélectionnez un élément",
emptySelectBody: "Sélectionnez un élément pour voir les détails et les actions.",
outcomeKindJob: "Suivi en tant que travail",
outcomeKindInspection: "Inspection demandée",
outcomeSummary: "Résumé",
fieldStatus: "Statut",
fieldPriority: "Priorité",
fieldProposedDate: "Créneau souhaité",
fieldScheduledFor: "Planifié pour",
fieldResolution: "Notes de résolution",
assetSummary: "Actif",
fieldAssetName: "Actif",
fieldAssetType: "Type",
fieldAssetStatus: "Statut de l'actif",
reporter: "Soumis par",
fieldContactName: "Nom",
fieldContactEmail: "E-mail",
timeline: "Progression",
timelinePending: "En attente",
timelineDone: "Terminé",
history: "Historique",
historyEmpty: "Aucune entrée d'historique pour l'instant.",
linkedWork: "Travail lié",
openLinkedJob: "Ouvrir l'intervention liée",
openLinkedInspection: "Ouvrir la visite planifiée",
actions: "Prochaines étapes",
actionApprove: "Approuver",
actionReject: "Refuser",
actionSchedule: "Planifier",
actionConvert: "Choisir un mode de traitement",
loggedContext: "Origine",
fieldSourceInspection: "Inspection",
fieldSourceJob: "Intervention",
fieldSourceSchedule: "Visite planifiée",
fieldSourceLocation: "Note de localisation",
fieldIntent: "Mode de signalement",
intentReport: "Signaler un problème",
intentFlag: "Signaler une anomalie",
intentRequestFix: "Demander une réparation",
intentEscalate: "Faire remonter",
historyActionSubmitted: "Enregistré pour tri",
historyActionApproved: "Approuvé",
historyActionRejected: "Refusé",
historyActionScheduled: "Planifié",
historyActionConvertedJob: "Intervention préparée à partir de la demande",
historyActionConvertedInspection: "Inspection préparée à partir de la demande",
historyActionCommented: "Commentaire ajouté",
aiAssistDisclosureTitle: "Assistance et brouillons",
aiAssistDisclosureSummary: "Résumés, reformulations et réponses suggérées",
},
approvalsWorkspace: {
toolbarOpenAssetFollowUps: "Ouvrir les suivis de l'actif",
toolbarChooseAsset: "Choisir un actif",
searchPlaceholder: "Rechercher par ID d'actif",
applyAssetFilter: "Appliquer le filtre d'actif",
applyTeamFilter: "Appliquer le filtre d'équipe",
listColumnFollowUp: "Suivi",
listColumnStatus: "Statut",
listColumnPriority: "Priorité",
listColumnDate: "Date",
listPaneTitle: "Demandes",
webStatusHint: "",
detailPaneTitle: "Détail",
mobileTitle: "Demandes",
mobileSubtitle: "Trier les suivis et préparer le travail.",
loadingQueue: "Chargement des approbations…",
emptyQueue: "Aucune demande ici",
emptyQueueHint: "Essayez les segments Envoyées ou Toutes, ou élargissez la portée.",
filterInspection: "Inspection",
filterJob: "Intervention",
countPending: "En attente",
countUrgent: "Urgent",
filterAssetPlaceholder: "Filtrer par ID d'actif",
filterTeamPlaceholder: "Filtrer par ID d'équipe",
statusFilterAll: "Tout",
statusFilterPending: "En attente",
statusFilterApproved: "Approuvé",
statusFilterScheduled: "Planifié",
statusFilterConverted: "Travail lié",
statusFilterRejected: "Refusé",
refine: "Affiner",
refineA11y: "Affiner les filtres de demandes",
refineSheetTitle: "Affiner les demandes",
nameSearchPlaceholder: "Rechercher des demandes par nom",
nameSearchA11y: "Rechercher des demandes par nom",
},
requestComposer: {
  duplicateBodyMore_other: "« {{title}} » et {{count}} autres sont toujours ouverts. Vous pouvez quand même envoyer le vôtre.",
  duplicateBodyMore_many: "« {{title}} » et {{count}} autres sont toujours ouverts. Vous pouvez quand même envoyer le vôtre.",
  duplicateBodyMore_one: "« {{title}} » et {{count}} autre sont toujours ouverts. Vous pouvez quand même envoyer le vôtre.",
  duplicateBody: "« {{title}} » est toujours ouvert sur cet équipement. Vous pouvez quand même envoyer le vôtre.",
  duplicateSimilar: "Une demande similaire est déjà ouverte",
  duplicateExact: "Ceci a peut-être déjà été signalé",
  summaryMissing: "Ajoutez d’abord un court résumé, puis réessayez.",
  ai: {
    signInBody: "Votre session a expiré. Reconnectez-vous, puis ajoutez la photo.",
    signInTitle: "Connectez-vous pour ajouter des photos",
    failedBody: "Réessayez dans un instant ou gardez votre texte.",
    failedTitle: "Impossible de retravailler ce texte",
    review: "Vérifiez-le avant de l’utiliser.",
    titleTitle: "Résumé retravaillé",
    detailsTitle: "Détails retravaillés",
  },
titles: {
default: "Signaler un problème",
report: "Déclarer un incident",
flag: "Signaler une anomalie",
requestFix: "Demander une intervention",
escalate: "Faire remonter",
followUp: "Proposer un suivi",
rework: "Proposer une reprise",
quote: "Proposer un devis",
},
proposal: {
kindHeading: "Que proposez-vous ?",
kindFollowUp: "Suivi",
kindRework: "Reprise",
kindQuote: "Un devis",
summaryPlaceholder: "ex. Remplacer la soupape de pression",
detailsLabel: "Ce qu’il faut faire et pourquoi",
detailsPlaceholder: "Ce que vous avez constaté, ce que vous feriez et ce qu’il faut savoir",
submit: "Envoyer la proposition",
},
close: "Fermer",
assetHeading: "Actif",
assetChoose: "Choisir un actif",
assetSearchPlaceholder: "Rechercher par nom d’actif…",
assetTypeAll: "Tous les types",
assetNoMatches: "Aucun actif ne correspond à la recherche et aux filtres.",
dictate: "Dicter",
dictationListening: "Écoute…",
dictationProcessing: "Insertion du texte…",
dictationStopping: "Fin de la dictée…",
dictationHeard: "Entendu : {{text}}",
aiPolish: "Retravailler avec l’IA",
contextHeading: "Contexte",
contextReporter: "Auteur : {{name}}",
contextInspection: "Issu d’une inspection",
contextJob: "Issu d’une intervention",
contextSchedule: "Issu d’une visite prévue",
outcomeHeading: "De quoi avez-vous besoin ?",
outcomeHelp: "Juste besoin d'aide — pas encore sûr",
outcomeJob: "Demander une intervention",
outcomeInspection: "Demander une inspection",
summaryLabel: "Résumé court",
summaryPlaceholder: "ex. contrôle de vanne en échec",
detailsLabel: "Ce que vous avez vu",
summaryPlaceholderRequester: "p. ex. Le robinet de la cuisine fuit",
detailsLabelRequester: "Quel est le problème ?",
detailsPlaceholderRequester: "Ce que vous avez constaté, où et depuis quand",
detailsPlaceholder: "Constat, risque et contraintes",
priorityLabel: "Priorité",
priorityNone: "Aucune",
priorityPickerTitle: "Priorité",
proposedDateLabel: "Moment souhaité (optionnel)",
proposedDatePlaceholder: "Choisir une date",
submit: "Envoyer",
submitRequester: "Envoyer le signalement",
submitting: "Envoi…",
assetChangeAccessibility: "Changer d’actif",
assetChange: "Modifier",
analyzeEvidence: "Lire les photos",
evidenceAddToDetails: "Ajouter le texte extrait aux détails",
},
followUpActionModal: {
  stop: "Arrêter",
  draft: "Rédiger avec l’IA",
  drafting: "Rédaction…",
  polishFailedBody: "Réessayez dans un instant.",
  polishFailedTitle: "Impossible de retravailler la note",
  draftFailedBody: "Réessayez ou écrivez-la vous-même.",
  draftFailedTitle: "Impossible de rédiger une question",
  polishReview: "Vérifiez la note avant de l’utiliser.",
  draftReview: "Vérifiez-la avant de l’envoyer.",
  draftedMessageTitle: "Question rédigée",
  polishedNotesTitle: "Note retravaillée",
  phNotes: "Ce qu’il doit savoir, par exemple quand quelqu’un passera.",
  phReject: "Pourquoi cela ne se fera pas. Le demandeur le voit.",
  phClose: "Pourquoi la clôturer ? Le motif reste sur la demande.",
  phReplied: "Sa réponse, telle que donnée par e-mail ou téléphone. Gardée sur la demande.",
  phAsk: "De quoi avez-vous besoin ? Il le reçoit par e-mail ou dans l’app.",
  labelNotes: "Note au demandeur (facultatif, il la voit)",
  labelReject: "Motif (le demandeur le voit)",
  labelClose: "Motif de clôture (facultatif, le demandeur le voit)",
  labelReplied: "Ce qu’il a dit (facultatif)",
  labelAsk: "Votre question (le demandeur la voit)",
  aiFallbackLabel: "Demande",
  loadAssigneesFailed: "Impossible de charger les personnes à attribuer. Réessayez.",
  searchAssignees: "Rechercher des personnes",
  loadingAssignees: "Chargement des personnes…",
  unassigned: "Personne pour l’instant",
  confirmSchedule: "Proposer cet horaire",
  confirmClose: "Clôturer la demande",
  confirmReplied: "Enregistrer sa réponse",
  confirmAsk: "Envoyer la question",
  confirmReject: "Refuser la demande",
  confirmApprove: "Approuver",
  closeTitle: "Clôturer la demande",
  repliedTitle: "Noter sa réponse",
  askTitle: "Poser une question au demandeur",
approveTitle: "Approuver la demande",
rejectTitle: "Refuser la demande",
scheduleTitle: "Planifier le travail",
convertTitle: "Convertir en travail",
cancel: "Annuler",
confirm: "Confirmer",
saving: "Enregistrement…",
targetLabel: "Type de résultat",
targetJob: "Intervention suivie",
targetInspection: "Inspection planifiée",
convertPickerTitle: "Convertir en",
},
inspections: {
screenTitle: "Inspections",
templates: "Check-lists",
runner: {
noItems: "Aucun élément",
noItemsInGroup: "Aucun élément dans ce groupe",
items_one: "{{count}} élément",
items_other: "{{count}} éléments",
groups_one: "{{count}} groupe",
groups_other: "{{count}} groupes",
questions_one: "{{count}} question",
questions_other: "{{count}} questions",
questionsShort: "{{count}} Q",
groupOf: "Groupe {{index}} sur {{total}}",
groupOfShort: "Groupe {{index}}/{{total}}",
itemOf: "Élément {{index}} sur {{total}}",
indexOfShort: "{{index}}/{{total}}",
inGroup: "Dans : {{group}}",
items_many: "{{count}} éléments",
groups_many: "{{count}} groupes",
questions_many: "{{count}} questions",
},
bulk: {
select: "Sélectionner des inspections",
selectA11y: "Sélectionner plusieurs inspections pour des actions groupées",
cancelSelection: "Annuler",
selected_one: "{{count}} sélectionnée",
selected_other: "{{count}} sélectionnées",
selectAllVisible: "Toutes visibles",
clearVisible: "Désélectionner les visibles",
selectAllA11y: "Sélectionner toutes les inspections visibles",
deselectAllA11y: "Désélectionner toutes les inspections visibles",
deleteInspections: "Supprimer",
deleteConfirmTitle: "Supprimer des inspections",
deleteConfirmMessage_one: "Supprimer {{count}} inspection ? Cette action est irréversible.",
deleteConfirmMessage_other: "Supprimer {{count}} inspections ? Cette action est irréversible.",
deleteConfirmAction: "Supprimer",
keep: "Conserver",
deleteSuccess_one: "{{count}} inspection supprimée",
deleteSuccess_other: "{{count}} inspections supprimées",
partialResult: "{{succeeded}} effectuées · {{failed}} ignorées",
allFailedTitle: "Rien n'a changé",
allFailedMessage: "Les inspections sélectionnées n'ont pas pu être supprimées. Veuillez réessayer.",
selected_many: "{{count}} sélectionnées",
deleteConfirmMessage_many: "Supprimer {{count}} inspections ? Cette action est irréversible.",
deleteSuccess_many: "{{count}} inspections supprimées",
},
createInspection: "Créer une inspection",
startInspection: "Démarrer une inspection",
searchA11y: "Rechercher des inspections",
searchPlaceholderPlanned: "Rechercher des inspections planifiées ?",
searchPlaceholderDefault: "Rechercher des inspections et des revues ?",
export: "Exporter",
exportCsvA11y: "Exporter les inspections en CSV",
refine: "Affiner",
refineA11y: "Affiner filtres et regroupements",
refineSheetTitle: "Affiner les inspections",
refineSearch: "Rechercher",
clearFilters: "Effacer les filtres",
manageTemplates: "Check-lists",
statusSectionLabel: "Statut",
bucketTablistLabel: "Statut d’inspection : tous, action requise, planifié ou historique",
statusHintLine: "La liste correspond à ce statut.",
viewToggleToListA11y: "Afficher les inspections planifiées en liste",
viewToggleToCalendarA11y: "Afficher les inspections planifiées au calendrier",
buckets: {
all: "Tous",
needsAction: "Action requise",
planned: "Planifié",
history: "Historique",
},
subtitles: {
allNone: "Aucune inspection pour l'instant",
allCount_one: "{{count}} inspection",
allCount_other: "{{count}} inspections",
needsActionNone: "Aucune action requise pour le moment",
needsActionCount_one: "{{count}} élément nécessite votre attention",
needsActionCount_other: "{{count}} éléments nécessitent votre attention",
plannedNone: "Aucune inspection planifiée",
plannedCount_one: "{{count}} inspection à venir",
plannedCount_other: "{{count}} inspections à venir",
historyNone: "Pas encore d’historique d’inspection",
historyCount_one: "{{count}} élément terminé, approuvé ou relu",
historyCount_other: "{{count}} éléments terminés, approuvés ou relus",
allCount_many: "{{count}} inspections",
needsActionCount_many: "{{count}} éléments nécessitent votre attention",
plannedCount_many: "{{count}} inspections à venir",
historyCount_many: "{{count}} éléments terminés, approuvés ou relus",
},
emptyFilteredTitle: "Aucun élément correspondant",
emptyFilteredSubtitle: "Essayez d’autres termes ou effacez les filtres d’affinage.",
emptyPlannedTitle: "Aucune inspection dans Planifié",
emptyPlannedSubtitle: "Créez une inspection planifiée depuis un actif ou une check-list, elle apparaîtra ici.",
emptyCalendarTitle: "Aucune inspection planifiée",
emptyCalendarSubtitle: "Le calendrier affiche les inspections avec une date planifiée. Passez en vue Cartes ou Liste pour voir toutes les inspections ici.",
emptyHistoryTitle: "Aucune inspection dans Historique",
emptyHistorySubtitle: "Les inspections terminées et relues apparaissent ici une fois finalisées.",
emptyAllTitle: "Aucune inspection pour l'instant",
emptyAllSubtitle: "Les inspections, validations et planifications apparaissent ici.",
emptyNeedsActionTitle: "Aucune inspection dans Action requise",
emptyNeedsActionSubtitle: "Lorsqu’une inspection nécessite votre attention, elle apparaît dans cette liste.",
followUp: {
logFromItem: "Enregistrer depuis l’élément de la liste de contrôle",
},
refineScope: "Périmètre",
refineGroupBy: "Regrouper par",
refineGroupByHint: "Sélectionnez une ou plusieurs options pour imbriquer les groupes",
refineFilters: "Filtres",
refineInspectionStage: "Phase d’inspection",
refineScheduleStage: "Phase de planification",
filterChipAsset: "Actif",
filterChipTemplate: "Check-list",
filterChipInspector: "Inspecteur",
groupByAsset: "Actif",
groupByInspector: "Inspecteur",
groupByTemplateCategory: "Catégorie de check-list",
groupingUnassigned: "Non assigné",
groupingUncategorized: "Sans catégorie",
inspectorAll: "Tous",
inspectorMe: "Moi",
inspectionStages: {
all: "Toutes les phases d’inspection",
allShort: "Toutes les phases",
draft: "Brouillon",
inProgress: "En cours",
completed: "Terminé",
approved: "Approuvé",
cancelled: "Annulé",
},
scheduleStages: {
all: "Toutes les phases de planification",
allShort: "Toutes",
upcoming: "À venir",
due: "Échéance",
overdue: "En retard",
},
reviewStages: {
pending: "Validation en attente",
responded: "Validation : réponse reçue",
awaitingReply: "Partagé — en attente de réponse",
awaitingVerification: "En attente de vérification",
column: {
triage: "Ouvert",
scheduled: "Planifié",
in_progress: "En cours",
awaiting_review: "En attente de validation",
},
},
kanban: {
dueAndOverdue: "Échéance et retard",
},
workflowStage: {
draft: "Brouillon",
in_progress: "En cours",
completed: "Terminé",
approved: "Approuvé",
cancelled: "Annulé",
},
pickerAllTemplates: "Tous les check-lists",
pickerTitleAsset: "Actif",
pickerTitleTemplate: "Check-list",
pickerTitleInspector: "Inspecteur",
reviewFallbackReport: "Rapport d’inspection",
reviewFallbackAsset: "Actif",
reviewStatusApproved: "Approuvé",
reviewStatusDeclined: "Refusé",
reviewStatusPending: "En attente de relecture",
resultsPanelA11y: "Résultats d’inspection pour le segment sélectionné",
fabCreateA11y: "Créer une inspection",
exportCsv: {
id: "ID",
template: "Check-list",
asset: "Actif",
status: "Statut",
stage: "Phase",
assignee: "Assigné",
lastActivity: "Dernière activité",
},
operationalInsight: {
title: "Analyse du registre d'inspections",
sourceLabel: "Inspections, planifications et validations existantes",
summaryLine: "{{bucketNeedsAction}} nécessitent une action · {{planned}} planifiées · {{history}} terminées pour cette portée",
overdueSchedExplanation_one: "{{count}} inspection planifiée est en retard.",
overdueSchedExplanation_many: "{{count}} inspections planifiées sont en retard.",
overdueSchedExplanation_other: "{{count}} inspections planifiées sont en retard.",
overdueSchedRecommended: "Démarrez-les ou replanifiez-les pour maintenir la couverture et la conformité.",
overdueSchedCta: "Afficher les planifications en retard",
pendingReviewExplanation_one: "{{count}} rapport partagé attend une réponse du validateur.",
pendingReviewExplanation_many: "{{count}} rapports partagés attendent une réponse du validateur.",
pendingReviewExplanation_other: "{{count}} rapports partagés attendent une réponse du validateur.",
pendingReviewRecommended: "Répondez ou relancez les validateurs pour ne pas bloquer les approbations.",
pendingReviewCta: "Ouvrir la prochaine validation",
dueSoonExplanation_one: "{{count}} inspection planifiée arrive bientôt à échéance.",
dueSoonExplanation_many: "{{count}} inspections planifiées arrivent bientôt à échéance.",
dueSoonExplanation_other: "{{count}} inspections planifiées arrivent bientôt à échéance.",
dueSoonRecommended: "Confirmez qui les réalisera et préparez le travail nécessaire.",
dueSoonCta: "Afficher les échéances proches",
inProgressExplanation_one: "{{count}} inspection est en brouillon ou en cours.",
inProgressExplanation_many: "{{count}} inspections sont en brouillon ou en cours.",
inProgressExplanation_other: "{{count}} inspections sont en brouillon ou en cours.",
inProgressRecommended: "Poursuivez les checklists, capturez les preuves et transférez si besoin.",
inProgressCta: "Se concentrer sur celles en cours",
healthyExplanation: "Aucune validation en attente ni planification en retard dans cette vue filtrée.",
healthyRecommended: "Utilisez Affiner pour changer la portée, le regroupement ou la recherche si vous avez besoin d'une liste plus précise.",
refineCta: "Ouvrir Affiner",
exportCsvLabel: "Exporter les inspections (CSV)",
wideCollapsedLead: "Développez pour voir les actions.",
widePanelLead: "Les actions correspondent à cette vue.",
},
tableHeaderWorkItem: "Élément de travail",
tableHeaderStatus: "Statut",
tableHeaderAssigned: "Assigné",
tableHeaderDueDate: "Échéance",
},
templates: {
  addIndustryPack: "Ajouter un pack sectoriel",
  emptyNoneSubtitlePacks: "Ajoutez les listes prêtes à l’emploi de votre métier, ou créez la vôtre.",
screenTitle: "Check-lists",
createManually: "Créer manuellement",
createManuallyA11y: "Créer manuellement",
refineScope: "Portée",
subtitleCount_one: "{{count}} check-list",
subtitleCount_other: "{{count}} check-lists",
fromPack_one: "{{count}} du pack {{pack}}",
fromPack_many: "{{count}} du pack {{pack}}",
fromPack_other: "{{count}} du pack {{pack}}",
inspectionsLink: "Inspections",
searchPlaceholder: "Rechercher des check-lists...",
searchPlaceholderWeb: "Rechercher des check-lists, catégories ou descriptions",
searchA11y: "Rechercher des check-lists",
refine: "Affiner",
refineSheetTitle: "Affiner les check-lists",
refineGroupBy: "Grouper par",
refineGroupByHint: "Sélectionnez-en un ou plusieurs pour imbriquer des groupes",
refineFilters: "Filtres",
filterAssetType: "Type d'actif",
filterCategory: "Catégorie",
groupByAssetType: "Type d'actif",
groupByCategory: "Catégorie",
pickerTitleAssetType: "Type d'actif",
pickerTitleCategory: "Catégorie",
allTypes: "Tous les types",
allCategories: "Toutes les catégories",
statusSectionLabel: "Statut",
bucketTablistLabel: "Statut de la check-list : Besoin d'action, Planifié ou Historique",
statusHintLine: "Besoin d'action, planifié et historique.",
refineA11y: "Affiner les filtres de check-lists",
clear: "Effacer",
clearA11y: "Effacer la recherche et les filtres",
generateWithAi: "Générer avec l'IA",
createChooserTitle: "Créer une check-list",
createChooserSubtitle: "Choisissez comment créer votre check-list.",
newTemplate: "Nouvelle check-list",
createTemplate: "Créer une check-list",
createTemplateA11y: "Créer une check-list",
newTemplateA11y: "Nouvelle check-list",
emptyNoneTitle: "Pas encore de check-lists de liste",
emptyNoneSubtitle: "Créez une check-list de liste de contrôle.",
emptyFilteredTitle: "Aucune check-list correspondant",
emptyFilteredSub: "Essayez d'autres termes de recherche ou effacez les filtres.",
clearFilters: "Effacer les filtres",
emptyBucketTitle: "Aucune check-list dans {{bucket}}",
emptyBucketSub: "Changez de segment ou effacez les filtres.",
goToNeedsAction: "Aller à Besoin d'action",
goToNeedsActionA11y: "Afficher les check-lists dans Besoin d'action",
inspectorHeading: "Inspecteur",
compatibility: "Compatibilité",
versioning: "Versions",
structure: "Structure",
visibility: "Visibilité",
description: "Description",
versioningCurrentId: "ID de la version actuelle : {{id}}",
versioningNotSet: "Non défini",
lastUpdatedPrefix: "Dernière mise à jour",
structureLine: "{{groups}} groupes / {{items}} éléments / {{conditional}} règles conditionnelles",
requiredChecks_one: "{{count}} contrôle obligatoire",
requiredChecks_many: "{{count}} contrôles obligatoires",
requiredChecks_other: "{{count}} contrôles obligatoires",
visibilityAllTeams: "Toutes les équipes",
visibilitySelectedTeams: "Équipes sélectionnées",
openTemplate: "Ouvrir la check-list",
edit: "Modifier",
useForInspection: "Démarrer une inspection",
detail: {
duplicate: "Dupliquer",
delete: "Supprimer",
sharedBadge: "Partagé",
notFound: "Check-list introuvable",
restrictToSelectedTeams: "Restreindre aux équipes sélectionnées",
shareWithAllTeams: "Partager avec toutes les équipes",
visibleToAllTeams: "Visible par toutes les équipes",
deleteConfirmTitle: "Supprimer le check-list",
deleteConfirmBody: "Supprimer « {{name}} » ? Les inspections passées qui l'ont utilisé conserveront leur enregistrement.",
cancel: "Annuler",
duplicatedTitle: "Dupliqué",
duplicatedBody: "Une copie de ce check-list a été créée.",
errorTitle: "Une erreur s'est produite",
failedToDelete: "Impossible de supprimer cette check-list. Veuillez réessayer.",
failedToDuplicate: "Impossible de dupliquer cette check-list. Veuillez réessayer.",
failedToUpdate: "Impossible de mettre à jour cette check-list. Veuillez réessayer.",
usedByTitle: "Utilisé dans",
usedByCount_one: "{{count}} inspection",
usedByCount_other: "{{count}} inspections",
usedByEmpty: "Aucune inspection n'a encore utilisé cette check-list.",
usedByOpenInspection: "Ouvrir l'inspection",
usedByCount_many: "{{count}} inspections",
},
selectTemplateTitle: "Sélectionnez une check-list",
selectTemplateSub: "Choisissez une ligne pour consulter sa structure, ses versions et ses actions d'utilisation.",
groupingUncategorized: "Sans catégorie",
labelGeneral: "Général",
labelAllAssets: "Tous les actifs",
fabNewTemplateA11y: "Nouvelle check-list",
buckets: {
all: "Tout",
needsAction: "Besoin d'action",
planned: "Planifié",
history: "Historique",
},
subtitleCount_many: "{{count}} check-lists",
},
jobs: {
followUp: {
requestFix: "Demander une réparation",
escalate: "Faire remonter",
logForTriage: "Enregistrer un suivi",
logForTriageHint: "Ouvre les suivis de cet actif avec le contexte de l'intervention pour Approbations.",
},
operationalInsight: {
summaryEmpty: "Aucune intervention ne correspond à la portée et aux filtres actuels.",
summaryCounts: "{{total}} interventions dans cette vue · {{overdue}} en retard · {{unassigned}} non assignées · {{unscheduled}} sans début planifié",
overdueExplanation_one: "{{count}} intervention a dépassé son début ou son échéance planifiés.",
overdueExplanation_many: "{{count}} interventions ont dépassé leur début ou leur échéance planifiés.",
overdueExplanation_other: "{{count}} interventions ont dépassé leur début ou leur échéance planifiés.",
overdueRecommended: "Confirmez le responsable, replanifiez, ou clôturez le travail déjà terminé.",
overdueCta: "Afficher les retards",
unassignedExplanation_one: "{{count}} intervention ouverte n'a pas d'assigné.",
unassignedExplanation_many: "{{count}} interventions ouvertes n'ont pas d'assigné.",
unassignedExplanation_other: "{{count}} interventions ouvertes n'ont pas d'assigné.",
unassignedRecommended: "Assignez chaque intervention pour que responsables, clients et prestataires sachent qui pilote le travail.",
unassignedCta: "Afficher les non assignées",
unscheduledExplanation_one: "{{count}} intervention acceptée a encore besoin d'un début planifié.",
unscheduledExplanation_many: "{{count}} interventions acceptées ont encore besoin d'un début planifié.",
unscheduledExplanation_other: "{{count}} interventions acceptées ont encore besoin d'un début planifié.",
unscheduledRecommended: "Définissez une fenêtre de démarrage avant que le travail ne dérape ou n'entre en conflit avec d'autres engagements.",
unscheduledCta: "Afficher les non planifiées",
urgentExplanation_one: "{{count}} intervention est marquée à forte urgence.",
urgentExplanation_many: "{{count}} interventions sont marquées à forte urgence.",
urgentExplanation_other: "{{count}} interventions sont marquées à forte urgence.",
urgentRecommended: "Recherchez les blocages, les preuves manquantes et les retards visibles par le client.",
urgentCta: "Filtrer par urgence élevée",
healthyExplanation: "Aucune intervention en retard, non assignée ou non planifiée dans cette vue filtrée.",
healthyRecommended: "Tenez à jour les dates, les assignés et les mises à jour au fil du travail.",
healthyCta: "Affiner les filtres",
exportCsvLabel: "Exporter les interventions visibles (CSV)",
wideCollapsedLead: "Développez pour voir les actions.",
widePanelLead: "Les actions correspondent à cette vue.",
},
screenTitle: "Interventions",
createJob: "Créer une intervention",
createJobA11y: "Créer une intervention",
searchPlaceholder: "Rechercher des interventions...",
searchPlaceholderWeb: "Rechercher des interventions, actifs, assignés...",
searchA11y: "Rechercher des interventions",
refine: "Affiner",
refineSheetTitle: "Affiner les interventions",
refineSearch: "Rechercher",
refineJobsA11y: "Affiner les filtres d'interventions",
refineScope: "Portée",
refineGroupBy: "Grouper par",
refineGroupByHint: "Sélectionnez-en un ou plusieurs pour imbriquer des groupes",
refineFilters: "Filtres",
refineStage: "Étape",
refineQuoteWorkflow: "Circuit de devis",
clearFilters: "Effacer les filtres",
advancedFiltersTitle: "Filtres et tri avancés",
advancedFiltersSummary_one: "{{count}} affinage actif",
advancedFiltersSummary_other: "{{count}} affinages actifs",
advancedFiltersSummaryEmpty: "Grouper par, filtres, étape, portée, tri",
advancedFiltersExpand: "Afficher les filtres",
advancedFiltersCollapse: "Masquer les filtres",
exportFilteredCsvA11y: "Exporter les interventions actuellement filtrées en CSV",
statusSectionLabel: "Statut",
bucketTablistLabel: "Statut des interventions : Tout, Besoin d'action, Planifié ou Historique",
statusHintLine: "La file correspond à ce groupe.",
switchToListA11y: "Passer les interventions en vue liste",
switchToCalendarA11y: "Passer les interventions en vue calendrier",
bucketsNative: {
all: "Tout",
needs_action: "Besoin d'action",
scheduled: "Planifié",
closed: "Clôturé",
},
bucketsWeb: {
all: "Tout",
needs_action: "Besoin d'action",
scheduled: "Planifié",
closed: "Historique",
},
sort: {
newest: "Plus récent d'abord",
oldest: "Plus ancien d'abord",
name_az: "Nom A-Z",
name_za: "Nom Z-A",
asset_name: "Nom de l'actif",
highest_cost: "Coût le plus élevé",
lowest_cost: "Coût le plus bas",
assignee: "Assigné à",
},
sortBy: "Trier par",
groupBy: {
asset: "Actif",
status: "Statut",
},
attention: {
all: "Tout",
overdue: "En retard",
unscheduled: "Non planifié",
},
webQueue: {
all: "Toutes actives",
overdue: "En retard",
awaiting_acceptance: "En attente d'acceptation",
unscheduled: "Non planifiées",
in_progress: "En cours",
due_soon: "Échéance proche",
other: "Planifiées plus tard",
},
quoteState: {
all: "Tous les états de devis",
awaiting_request: "En attente de demande de devis",
requested: "Demande de devis liée",
awarded: "Devis retenu",
},
quoteLinked: "Lié",
quoteNone: "Aucun",
priority: {
all: "Toutes",
low: "Faible",
medium: "Moyenne",
high: "Élevée",
critical: "Critique",
},
deliveryAll: "Tous",
deliveryMode: {
INTERNAL: "Interne",
DIRECT_CONTRACTOR: "Prestataire direct",
PRIVATE_QUOTES: "Devis privés",
},
categoryAll: "Toutes les catégories",
assigneeAll: "Tous les assignés",
assigneeUnassigned: "Non assigné",
assigneeAssignedFallback: "Assigné",
filterChip: {
asset: "Actif",
category: "Catégorie",
workPath: "Mode de traitement",
priority: "Priorité",
attention: "Attention",
sort: "Tri",
assignee: "Assigné à",
quoteState: "État du devis",
},
pickerTitle: {
asset: "Actif",
category: "Catégorie",
workPath: "Mode de traitement",
priority: "Priorité",
sortBy: "Trier par",
attention: "Attention",
assignee: "Assigné à",
quoteState: "État du devis",
},
stages: {
all: {
all: "Toutes",
},
needs_action: {
all: "Toutes",
draft: "Brouillon",
open: "Ouverte",
accepted: "Acceptée",
completed: "Terminée",
rejected: "Refusée",
},
scheduled: {
all: "Toutes",
scheduled: "Planifiée",
in_progress: "En cours",
paused: "Suspendue",
},
closed: {
all: "Toutes",
verified: "Vérifiée",
cancelled: "Annulée",
},
},
grouping: {
noAsset: "Aucun actif",
noSkill: "Aucune compétence",
unassigned: "Non assigné",
uncategorized: "Sans catégorie",
},
analytics: {
assigneeChannel: {
unassigned: "Non assigné",
team_member: "Membre de l'équipe",
contractor: "Prestataire",
type_unset: "Assigné (type non défini)",
},
privateQuotesPipeline: {
awaitingRequest: "Aucune demande de devis encore",
requested: "En attente d'attribution",
awarded: "Devis retenu (en cours)",
},
notSet: "Non défini",
},
urgency: {
normal: "Normale",
low: "Faible",
medium: "Moyenne",
high: "Élevée",
},
relative: {
justNow: "À l'instant",
minutesAgo: "il y a {{count}} min",
hoursAgo: "il y a {{count}} h",
},
sortDash: "-",
alerts: {
cancelTitle: "Annuler l'intervention",
cancelMessage: "Êtes-vous sûr ? L'intervention sera marquée comme annulée.",
keep: "Conserver",
cancelConfirm: "Annuler l'intervention",
deleteTitle: "Supprimer l'intervention",
deleteMessage: "Cette action est irréversible. L'intervention sera définitivement supprimée.",
deleteConfirm: "Supprimer",
errorTitle: "Erreur",
failedCancel: "Échec de l'annulation",
failedDelete: "Échec de la suppression",
acceptFailedTitle: "Impossible d'accepter l'intervention",
acceptFailedMessage: "Veuillez réessayer.",
},
bulk: {
select: "Sélectionner des interventions",
selectA11y: "Sélectionner plusieurs interventions pour des actions groupées",
cancelSelection: "Annuler",
selected_one: "{{count}} sélectionnée",
selected_other: "{{count}} sélectionnées",
selectAllVisible: "Toutes visibles",
clearVisible: "Désélectionner les visibles",
selectAllA11y: "Sélectionner toutes les interventions visibles",
deselectAllA11y: "Désélectionner toutes les interventions visibles",
cancelJobs: "Annuler",
deleteJobs: "Supprimer",
cancelConfirmTitle: "Annuler des interventions",
cancelConfirmMessage_one: "Annuler {{count}} intervention ? Elle sera marquée comme annulée.",
cancelConfirmMessage_other: "Annuler {{count}} interventions ? Elles seront marquées comme annulées.",
cancelConfirmAction: "Annuler les interventions",
deleteConfirmTitle: "Supprimer des interventions",
deleteConfirmMessage_one: "Supprimer {{count}} intervention ? Cette action est irréversible.",
deleteConfirmMessage_other: "Supprimer {{count}} interventions ? Cette action est irréversible.",
deleteConfirmAction: "Supprimer",
keep: "Conserver",
noneCancellable: "Aucune des interventions sélectionnées ne peut être annulée.",
cancelSuccess_one: "{{count}} intervention annulée",
cancelSuccess_other: "{{count}} interventions annulées",
deleteSuccess_one: "{{count}} intervention supprimée",
deleteSuccess_other: "{{count}} interventions supprimées",
partialResult: "{{succeeded}} effectuées · {{failed}} ignorées",
allFailedTitle: "Rien n'a changé",
allFailedMessage: "Les interventions sélectionnées n'ont pas pu être mises à jour. Veuillez réessayer.",
selected_many: "{{count}} sélectionnées",
cancelConfirmMessage_many: "Annuler {{count}} interventions ? Elles seront marquées comme annulées.",
deleteConfirmMessage_many: "Supprimer {{count}} interventions ? Cette action est irréversible.",
cancelSuccess_many: "{{count}} interventions annulées",
deleteSuccess_many: "{{count}} interventions supprimées",
},
emptyNoJobs: "Aucune intervention",
emptyNoMatching: "Aucune intervention correspondante",
emptyFilteredHint: "Essayez d'autres termes de recherche ou effacez les filtres.",
subtitleAttentionSummary: "{{overdue}} en retard · {{unscheduled}} non planifiées",
webSubtitleSummary: "{{total}} interventions · {{overdue}} en retard · {{inProgress}} en cours · {{dueSoon}} échéance proche",
noAssetLinked: "Aucun actif lié",
metaAsset: "Actif",
metaPriority: "Priorité",
overview: {
queue: "File",
status: "Statut",
assignee: "Assigné à",
workPath: "Mode de traitement",
schedule: "Planification",
nextStep: "Prochaine étape",
started: "Commencée",
completed: "Terminée",
duration: "Durée",
quoteState: "État du devis",
summary: "Résumé",
inspection: "Inspection",
},
notSet: "non défini",
emDash: "—",
nextStepFallback: "Consulter tous les détails",
workflowNextStep: {
awaitingFollowOn: "En attente d'approbation du suivi",
draft: "Consulter les détails et ouvrir l'intervention",
openAwaitingAcceptance: "Accepter ou refuser l'intervention",
openSchedule: "Planifier l'intervention",
openAssign: "Assigner l'intervention",
rejected: "Examiner le refus et réassigner",
scheduled: "Démarrer l'intervention",
inProgress: "Terminer ou suspendre",
inProgressRework: "Resoumettre l'achèvement",
paused: "Reprendre ou replanifier",
completed: "Vérifier ou demander une reprise",
},
verifyCompletion: {
title: "Valider le travail",
message: "Valider ce travail ? La personne qui l’a fait sera prévenue.",
confirm: "Valider",
},
video: {
unsupportedSource: "Impossible de lire cette vidéo depuis cet emplacement.",
loadFailed: "Impossible de charger la vidéo.",
},
notScheduled: "Non planifiée",
openInspectionA11y: "Ouvrir l'inspection {{label}}",
media: {
closeImageViewer: "Fermer la visionneuse d’images",
closeVideoViewer: "Fermer le lecteur vidéo",
},
kpi: {
overdueLabel: "En retard",
overdueSub: "Nécessite une action immédiate",
inProgressLabel: "En cours",
inProgressSub: "Actuellement en exécution",
dueSoonLabel: "Échéance proche",
dueSoonSub: "72 prochaines heures",
},
command: {
openCalendar: "Ouvrir le calendrier",
createJob: "Créer une intervention",
refine: "Affiner",
clearFilters: "Effacer les filtres",
exportCsv: "Exporter en CSV",
},
exportCsvHeaders: {
title: "Titre",
status: "Statut",
asset: "Actif",
priority: "Priorité",
assignee: "Assigné à",
updated: "Mis à jour",
},
inspector: {
openJob: "Ouvrir l'intervention",
addUpdate: "Ajouter une mise à jour",
accept: "Accepter",
reject: "Refuser",
assign: "Assigner",
schedule: "Planifier",
start: "Démarrer",
pause: "Suspendre",
resume: "Reprendre",
complete: "Terminer",
approve_rework: "Approuver la reprise",
verify: "Vérifier",
rework: "Reprise",
},
workQueueHeading: "File de travail",
queueEmpty: "Aucune intervention dans cette file.",
emptyMatchingWebTitle: "Aucune intervention correspondante",
emptyMatchingWebSub: "Essayez une autre file ou effacez les filtres.",
emptyBucketTitle: "Aucune intervention dans {{bucket}}",
emptyBucketSub: "Passez à Besoin d'action, Planifié ou Historique, ou effacez les filtres pour élargir les résultats.",
goToNeedsAction: "Aller à Besoin d'action",
goToNeedsActionA11y: "Afficher les interventions dans Besoin d'action",
clearJobFiltersA11y: "Effacer les filtres d'interventions",
panelHeading: "Détails de l'intervention",
emptyScopeTitle: "Aucune intervention dans la portée",
emptyScopeSub: "Ajustez vos filtres, votre file ou la portée de l'équipe pour charger des interventions.",
sectionOverview: "Aperçu",
sectionActivity: "Activité",
noActivityYet: "Aucune activité pour l'instant.",
loading: "Chargement des interventions…",
emptyNoJobsYet: "Aucune intervention pour l'instant",
emptyRecipientSub: "Les interventions issues des inspections partagées avec vous apparaîtront ici une fois que l'inspecteur les aura créées à partir des réparations approuvées.",
emptyOwnerSub: "Créez une intervention directement ou convertissez les réparations approuvées d'une inspection partagée.",
viewActivity: "Voir l'activité",
canonicalStatus: {
  skipped: "Ignoré",
draft: "Brouillon",
open: "Ouverte",
accepted: "Acceptée",
scheduled: "Planifiée",
in_progress: "En cours",
paused: "Suspendue",
completed: "Terminée",
verified: "Validée",
rejected: "Refusée",
cancelled: "Annulée",
},
fabCreateA11y: "Créer une intervention",
detailWorkPath: {
change: "Changer le mode de traitement",
sheetTitle: "Mode de traitement",
sheetHint: "Choisissez comment cette intervention est réalisée : équipe interne, un seul prestataire, ou demande de devis.",
team: "Équipe",
contractor: "Prestataire",
quotes: "Devis",
},
advancedFiltersSummary_many: "{{count}} affinages actifs",
},
inspectionDetail: {
firstRunMomentumHint: "Répondez à chaque élément par Réussi, Échec ou S.O. Touchez Suivi pour tout ce qui a besoin d’une intervention.",
firstRunGotIt: "OK",
firstRunReportCta: "Signaler un problème",
reportIssueNow: "Signaler un problème maintenant",
completeInspection: "Terminer l'inspection",
completeShort: "Terminer",
continueInspection: "Continuer l'inspection",
continueShort: "Continuer",
manage: "Gérer",
manageSheetTitle: "Actions d'inspection",
reassign: "Réassigner",
pause: "Suspendre",
cancel: "Annuler l’inspection…",
viewReport: "Voir le rapport",
nextSteps: "Prochaines étapes",
share: "Partager",
createJobs: "Créer des interventions",
sendForApproval: "Envoyer pour approbation",
shareReport: "Partager le rapport",
planFollowUp: "Planifier un suivi",
planFollowUpHint: "Étapes facultatives après la fin de cette inspection.",
saveTemplate: "Enregistrer la check-list",
repeatOnSchedule: "Répéter selon une planification",
createJobNow: "Créer une intervention maintenant",
notifyTeam: "Notifier l'équipe",
moreMenuA11y: "Plus d'actions d'inspection",
},
assetDetail: {
  shareChooser: {
    intakeDescription: "Sans compte ni connexion. Chaque signalement arrive dans Travail comme une demande, prête pour planifier une inspection ou une intervention.",
    intakeTitle: "Permettre à toute personne ayant le code de signaler un problème",
    personDescription: "Ils voient cet équipement, ses inspections et ses documents. Choisissez Peut demander du travail à l’étape suivante s’ils doivent aussi signaler des problèmes.",
    personTitle: "Partager avec une personne ou une équipe",
  },
  publicIntakeCard: {
    turnOff: "Désactiver",
    keepOn: "Laisser activé",
    turnOffBody: "Les codes imprimés et les liens partagés ne fonctionneront plus jusqu’à la réactivation.",
    turnOffTitle: "Désactiver le signalement ?",
    copyFailedBody: "Réessayez. Vous pouvez aussi faire une capture d’écran du code et la partager.",
    copyFailedTitle: "Impossible de copier le lien",
    linkCopied: "Lien copié. Collez-le là où les gens doivent signaler les problèmes.",
    tryAgain: "Vérifiez votre connexion et réessayez.",
    updateFailedTitle: "Le signalement n’a pas été modifié",
    turnedOff: "Le signalement est désactivé. Le code et le lien n’acceptent plus de signalements.",
    turnedOn: "Le signalement est activé. Imprimez le code ou copiez le lien ci-dessous et placez-le bien en vue.",
    printBody: "Scannez pour signaler un problème. Aucun compte ni connexion nécessaire.",
    printTitle: "Signaler un problème — {{name}}",
    popupBlockedBody: "Autorisez les fenêtres pour ce site afin d’imprimer, ou utilisez Copier le lien.",
    popupBlockedTitle: "Fenêtre bloquée",
    noWebAddress: "Le signalement est activé, mais cette version de l’app ne peut pas créer le lien. Ouvrez cet équipement dans AssetWRX depuis un navigateur pour copier le lien ou imprimer le code.",
    copyLinkA11y: "Copier le lien pour signaler un problème",
    step3: "3. Ils décrivent le problème. Il apparaît dans Travail comme une demande à examiner.",
    qrLabel: "Code pour signaler un problème",
    title: "Permettre à tous de signaler un problème",
  },
overviewInspectionEmpty: "Aucune inspection pour l'instant. Utilisez",
startInspection: "Démarrer l'inspection",
createJob: "Créer une intervention",
edit: "Modifier",
contactsSectionTitle: "Contacts liés",
viewActivity: "Voir l'activité",
toolsAi: "Outils et IA",
generateAdvancedReport: "Asset 360",
askAi: "Demander à l'IA",
suggestNextSteps: "Suggérer les prochaines étapes",
shareThisAssetModalTitle: "Partager cet actif",
shareThisAssetAccessOnlySubtitle: "Donnez à une personne ou une équipe l'accès à la fiche, aux inspections et aux documents de cet actif.",
shareWithPersonAccessOnlyDescription: "Ils voient la fiche, les inspections et les documents de cet actif.",
linkContactModalTitle: "Lier un contact",
shareWithContactCallout: "Partager cet actif avec {{name}}",
journey: {
title: "Parcours opérationnel",
stage: {
created: "Créé",
inspected: "Inspections terminées",
issues: "Problèmes enregistrés",
requests: "Demandes soulevées",
jobs: "Interventions terminées",
reports: "Rapports générés",
},
window: {
"30d": "30j",
"90d": "90j",
"365d": "1 an",
all: "Tout",
},
windowLabel: {
"30d": "Sur les 30 derniers jours",
"90d": "Sur les 90 derniers jours",
"365d": "Sur les 12 derniers mois",
all: "Sur tout l'historique de cet actif",
},
readOnlyHint: "Vous disposez d'un accès en lecture seule au parcours de cet actif.",
a11ySummaryLabel: "Résumé du parcours opérationnel",
a11yStageHint: "{{label}} : {{count}} sur la période",
a11yStageSubline: "{{label}} : {{count}} sur la période, {{subline}}",
zeroInWindow: "0 sur {{window}}",
dateUnavailable: "Date indisponible",
ago: {
minutes: "il y a {{n}} min",
hours: "il y a {{n}} h",
days: "il y a {{n}} j",
months_one: "il y a {{count}} mois",
months_many: "il y a {{count}} mois",
months_other: "il y a {{count}} mois",
years_one: "il y a {{count}} an",
years_many: "il y a {{count}} ans",
years_other: "il y a {{count}} ans",
},
in: {
minutes: "dans {{n}} min",
hours: "dans {{n}} h",
days: "dans {{n}} j",
},
sublineIssueBreach: "{{days}} j+ sans demande",
sublineAwaitingApproval_one: "{{count}} en attente d’approbation",
sublineAwaitingApproval_many: "{{count}} en attente d’approbation",
sublineAwaitingApproval_other: "{{count}} en attente d’approbation",
summary: {
noActivity: "{{window}}, cet actif n’a aucune activité enregistrée.",
recommendBaseline: "Nous recommandons de planifier une inspection de référence.",
hadBoth: "{{window}}, cet actif a eu {{inspections}} et {{jobs}}.",
hadOne: "{{window}}, cet actif a eu {{what}}.",
hadNone: "{{window}}, cet actif n’a encore aucun travail terminé.",
inspections_one: "{{count}} inspection",
inspections_many: "{{count}} inspections",
inspections_other: "{{count}} inspections",
jobsCompleted_one: "{{count}} intervention terminée",
jobsCompleted_many: "{{count}} interventions terminées",
jobsCompleted_other: "{{count}} interventions terminées",
healthImproved: "La santé opérationnelle est passée de {{then}}/100 à {{now}}/100.",
healthDeclined: "La santé opérationnelle a baissé de {{then}}/100 à {{now}}/100.",
healthCurrent: "La santé opérationnelle actuelle est de {{now}}/100, d’après la conformité, les plannings, les interventions, les approbations et les constats d’inspection.",
conditionUnscored_one: "L’état d’inspection n’est pas noté : l’unique inspection terminée ({{count}}) n’a pas de note valide de 1 à 5.",
conditionUnscored_many: "L’état d’inspection n’est pas noté : aucune des {{count}} inspections terminées n’a de note valide de 1 à 5.",
conditionUnscored_other: "L’état d’inspection n’est pas noté : aucune des {{count}} inspections terminées n’a de note valide de 1 à 5.",
conditionOneRated: "L’état d’inspection compte une inspection notée ; il en faut une de plus pour afficher une tendance.",
issueOverdue: "Un problème ouvert attend une demande depuis trop longtemps.",
requestsAwaiting_one: "Une demande est en attente d’approbation.",
requestsAwaiting_many: "{{count}} demandes sont en attente d’approbation.",
requestsAwaiting_other: "{{count}} demandes sont en attente d’approbation.",
excluded_one: "{{count}} inspection terminée a été exclue : {{reasons}}.",
excluded_many: "{{count}} inspections terminées ont été exclues : {{reasons}}.",
excluded_other: "{{count}} inspections terminées ont été exclues : {{reasons}}.",
excludedMissing: "{{n}} sans date de fin",
excludedInvalid: "{{n}} avec une date de fin non valide",
excludedFuture: "{{n}} datée(s) dans le futur",
},
},
},
quickComplete: {
moreOptions: "Assistant d'achèvement avancé",
moreOptionsA11y: "Ouvrir l'assistant d'achèvement avancé",
eyebrow: "Clôture rapide",
needsMore: {
  invoice: "Cette intervention nécessite aussi ses coûts et sa facture. Continuer les ajoute, puis la termine.",
  meter: "Cette intervention nécessite aussi un relevé de compteur. Continuer le demande, puis la termine.",
  checks: "Un point doit être réglé avant de terminer cette intervention. Continuer indique lequel.",
},
onePageTitle: "Terminer l’intervention",
continue: "Continuer",
submit: "Terminer l'intervention",
step1: {
title: "Note rapide",
noteLabel: "Qu'avez-vous fait ?",
notePlaceholder: "Une ligne — réparé, remplacé, inspecté, nettoyé.",
noteA11y: "Note de clôture rapide",
dictateStart: "Dicter",
dictateStop: "Arrêter la dictée",
chipsLabel: "Ou touchez une étiquette rapide",
},
step2: {
title: "Ajouter une preuve",
summary: "Prenez une photo ou joignez un document. Facultatif, mais recommandé.",
unavailable: "Impossible d’ajouter des preuves ici.",
},
step3: {
title: "Soumettre",
summary: "Confirmez et terminez.",
note: "Note",
noNote: "Aucune note ajoutée",
tags: "Étiquettes",
evidence: "Preuve",
outcome: "Résultat",
},
},
changeRequest: {
comeBack: {
  title: "Je dois revenir",
  hint: "Une autre visite un autre jour. Le travail reste ouvert et se termine une seule fois, à la fin.",
},
open: "Impossible de terminer comme prévu",
openA11y: "Signaler que vous ne pouvez pas terminer comme prévu",
eyebrow: "Modification demandée",
step1: {
title: "Qu'est-ce qui vous a arrêté ?",
summary: "Choisissez la raison la plus proche. Elle détermine qui doit être informé.",
},
step2: {
  datePlaceholder: "Choisir un jour",
title: "De quoi avez-vous besoin ?",
summary: "Votre responsable décide. Rien ne change jusqu'à sa décision.",
summaryImmediate: "Pour ce plan, ignorer une occurrence prend effet immédiatement. Le reste est envoyé à votre responsable.",
dateLabel: "Reporter au",
assigneeLabel: "Suggérer une personne",
assigneeHint: "Une suggestion — votre responsable peut choisir quelqu'un d'autre.",
},
step3: {
title: "Autre chose ?",
noteLabel: "Ajouter un détail",
notePlaceholder: "Ce que vous avez constaté, à qui vous avez parlé, ce qui permettrait de débloquer.",
evidencePrompt: "Une photo facilite grandement l'approbation.",
submit: "Envoyer la demande",
submitImmediate: "Ignorer cette occurrence",
submitting: "Envoi…",
},
reason: {
no_access: "Pas d'accès",
asset_unavailable: "Actif indisponible",
asset_in_use: "Actif en cours d'utilisation",
unsafe: "Dangereux de continuer",
parts_unavailable: "Pièces indisponibles",
time_insufficient: "Pas assez de temps",
meter_inaccessible: "Compteur inaccessible",
specialist_required: "Spécialiste requis",
wrong_assignee: "Devrait être quelqu'un d'autre",
done_elsewhere: "Déjà fait ailleurs",
not_required: "Non requis",
bigger_than_described: "Plus important que décrit",
other: "Autre chose",
},
action: {
reschedule: "Reporter",
rescheduleBlurb: "Même travail, même personne, une date ultérieure.",
rescope: "Demande plus que prévu",
rescopeBlurb: "Même travail, même personne, mais plus important que décrit. Indiquez le temps réellement nécessaire.",
rescopeLength: "Combien de temps faut-il vraiment ? (minutes)",
reassign: "Quelqu'un d'autre",
reassignBlurb: "Même travail, toujours dû, une personne différente.",
skip: "Ignorer cette occurrence",
skipBlurb: "Cette intervention ne sera pas faite. La suivante reste due.",
},
status: {
  waitingOnApprover: "En attente de la décision de l'approbateur de l'actif. Vous recevrez une notification.",
pending: "Modification demandée",
waitingOn: "En attente de la décision de {{name}}. Vous recevrez une notification.",
approved: "Modification approuvée",
rejected: "Modification non approuvée",
stillDue: "Ce travail reste dû",
},
review: {
  closeStale: "Fermer la demande",
  changedSinceDecide: "Ce travail a changé après l'envoi de la demande : elle ne peut plus être approuvée. Fermez-la avec une note ; la personne pourra redemander si besoin.",
title: "Examiner la demande",
requestedBy: "Demandé par {{name}}",
asked: "Demandé",
reason: "Raison",
evidence: "Preuve",
current: "Actuellement",
proposed: "Proposé",
changedSince: "Ce travail a changé depuis que la demande a été soulevée.",
approve: "Approuver",
reject: "Refuser",
editAndApprove: "Modifier et approuver",
rejectNeedsNote: "Indiquez pourquoi avant de refuser",
changeDate: "Approuver une autre date",
changeAssignee: "Approuver quelqu'un d'autre",
note: "Ajouter une note",
complianceWarning: "Cet actif est soumis à une obligation de conformité.",
},
},
completeWizard: {
needs: {
  title: "Vérifications et preuves",
  summary: "Cochez la liste et ajoutez les photos. Les photos sont vérifiées automatiquement par rapport à l'intervention.",
},
eyebrow: "Terminer l'intervention",
addCosts: "Ajouter les coûts et la facture",
submit: "Soumettre l'achèvement",
step1: {
title: "Notes",
noteLabel: "Qu'avez-vous fait ?",
notePlaceholder: "Résumé court — ce que vous avez réparé, remplacé, inspecté.",
noteA11y: "Note d'achèvement",
chipsLabel: "Tags rapides",
dictate: "Dicter",
dictateStart: "Dicter",
dictateStop: "Arrêter la dictée",
improve: "Améliorer avec l'IA",
improving: "Amélioration…",
},
step2: {
title: "Preuves",
summary: "Ajoutez une preuve du travail effectué. Photos, documents ou facture si besoin.",
addPhoto: "Ajouter une photo",
addDocument: "Ajouter un document",
addInvoice: "Ajouter une facture",
count_one: "{{count}} élément joint",
count_other: "{{count}} éléments joints",
empty: "Aucune preuve jointe pour l'instant.",
count_many: "{{count}} éléments joints",
analyze: "Lire les photos",
addToNote: "Ajouter le texte extrait à la note",
},
step3: {
title: "Coûts et facture",
summary: "Indiquez ce que cette intervention a coûté. Ajoutez une facture ou un reçu si vous en avez.",
summaryInvoice: "Indiquez ce que cette intervention a coûté et joignez une facture. Ce client l’exige.",
empty: "Aucun éditeur de coûts disponible ici. Utilisez la vue de gestion pour saisir les coûts.",
},
step4: {
title: "Résultat",
summary: "Comment cette intervention s'est-elle terminée ?",
followUpHint: "Nous proposerons de créer une intervention de suivi après votre soumission.",
},
step5: {
title: "Vérifier et soumettre",
summary: "Confirmez ce qui sera soumis.",
note: "Note",
noNote: "Aucune note ajoutée",
tags: "Étiquettes",
evidence: "Preuves",
outcome: "Résultat",
cost: "Coût",
noCost: "Non enregistré",
invoice: "Facture",
invoiceNone: "Aucune",
evidenceNone: "Aucune",
blockersTitle: "À corriger avant de soumettre :",
invoiceAttached: "{{n}} jointe(s)",
invoiceRequiredMissing: "Obligatoire — aucune jointe",
invoiceRequiredBlocker: "Ce client exige une facture. Joignez-en une dans Coûts et facture, ou générez-la là-bas.",
},
chips: {
fixed: "Réparé",
replaced: "Remplacé",
inspected: "Inspecté",
cleaned: "Nettoyé",
needsFollowUp: "Nécessite un suivi",
unableToComplete: "Impossible à terminer",
},
outcomes: {
completed: "Terminé",
partial: "Partiellement terminé",
followUp: "Nécessite un suivi",
unable: "Impossible à terminer",
},
step0: {
title: "Post-vérification",
done: "Toutes les vérifications sont terminées. Continuez pour clôturer l’intervention.",
summary: "Répondez à chaque étape de la vérification finale. L’intervention ne peut pas être soumise tant qu’elle n’est pas terminée.",
},
},
jobMode: {
switcher: {
enterFocus: "Mode focus",
exitFocus: "Intervention complète",
a11yEnterFocus: "Se concentrer sur l’exécution — masquer les détails de gestion",
a11yExitFocus: "Afficher l’espace de travail complet",
},
report: {
open: "Ouvrir le rapport d’achèvement",
title: "Rapport de clôture",
fallbackTitle: "Intervention",
missingJob: "Intervention introuvable.",
followOn: "Travail de suivi",
shareTitle: "Partager le rapport de clôture",
shareAction: "Partager",
shareReviewLink: "Partager le lien de vérification",
shareSheetTitle: "Partager le rapport",
summaryEyebrow: "Résumé de clôture",
notesEyebrow: "Notes de clôture",
noNotes: "—",
checksEyebrow: "Vérifications avant et après",
evidenceEyebrow: "Preuves et pièces jointes",
recentExports: "Exportations récentes",
optionsTitle: "Options de rapport",
fields: {
job: "Intervention",
jobType: "Type d’intervention",
parentJob: "Intervention parente",
asset: "Actif",
location: "Lieu",
assignedTo: "Affecté à",
status: "Statut",
submitted: "Soumis",
verified: "Vérifiée",
completed: "Terminé",
actualCost: "Coût réel",
},
},
},
maintenance: {
  steps: {
    keep: "Garder les étapes",
    close: "Fermer",
    failed: "Impossible d'enregistrer les étapes",
    unlinked: "Étapes déliées. Chacune redevient un plan à part.",
    unlinkConfirm: "Délier",
    unlinkMessage: "Chaque étape redevient un plan à part et garde son calendrier. Rien n’est supprimé.",
    unlinkTitle: "Délier ces étapes ?",
    unlink: "Délier les étapes",
    saved: "Étapes enregistrées.",
    save: "Enregistrer les étapes",
    inOrderOff: "Chaque étape revient selon son propre calendrier.",
    inOrderOn: "Le travail d'une étape n'est créé que lorsque l'étape précédente n'a plus de travail ouvert.",
    inOrderTitle: "Faire les étapes dans l'ordre",
    moveDownA11y: "Descendre {{name}}",
    moveUpA11y: "Monter {{name}}",
    removeA11y: "Retirer {{name}} des étapes",
    addA11y: "Ajouter {{name}} comme étape",
    add: "Ajouter",
    inOtherSet: "Actuellement une étape de {{name}}",
    otherLabel: "Autres plans de cet actif",
    needTwo: "Ajoutez au moins deux plans de la liste ci-dessous.",
    stepsLabel: "Étapes, dans l'ordre",
    namePlaceholder: "Par exemple : Entretiens du groupe électrogène",
    nameLabel: "Nom",
    intro: "Les étapes sont des plans qui vont ensemble, comme un entretien à 500, 1 000 et 2 000 heures.",
    titleEdit: "Modifier les étapes",
    titleNew: "Lier des plans en étapes",
    addStep: "Ajouter une étape",
    editSteps: "Modifier les étapes",
    linkSteps: "Lier des plans en étapes",
  },
  list: {
    status: {
      cancelled: "Annulé",
      ended: "Terminé",
      paused: "En pause",
      active: "Actif",
    },
    openJobA11y: "Ouvrir l’intervention en cours de {{name}}",
    editA11y: "Modifier {{name}}",
    untitled: "Plan sans titre",
    groupA11y: "{{asset}} : {{n}} plans. Ouvre l’actif.",
    emptyBody: "Ajoutez un plan pour un travail qui revient : un entretien mensuel, un test annuel. À chaque échéance, l’intervention apparaît dans Travail.",
    tryAgain: "Réessayer",
    loadFailed: "Impossible de charger les plans de maintenance. Vérifiez votre connexion et réessayez.",
    activeMany: "{{live}} plans en cours",
    activeOne: "1 plan en cours",
    noneActive: "Aucun plan en cours. Reprenez-en un ou ajoutez-en un nouveau.",
    dueInDays: "Prochaine échéance dans {{days}} jours",
    dueTomorrow: "Prochaine échéance demain",
    dueToday: "Prochaine échéance aujourd’hui",
    overdueDays: "En retard de {{days}} jours",
    overdueOneDay: "En retard de 1 jour",
    doneCount: "{{done}} créées",
    doneOfMax: "{{done}} sur {{max}} créées",
  },
  cadence: {
    fromLastDone: "{{cadence}}, compté à partir de la fin de la précédente",
    oneOff: "Ponctuel",
    either: "{{first}} ou {{second}} — au premier des deux termes",
    everyAmount: "Tous les {{amount}}",
    everyNYears_one: "Tous les {{count}} an",
    everyNYears_many: "Tous les {{count}} ans",
    everyNYears_other: "Tous les {{count}} ans",
    everyYear: "Tous les ans",
    everyNMonths_one: "Tous les {{count}} mois",
    everyNMonths_many: "Tous les {{count}} mois",
    everyNMonths_other: "Tous les {{count}} mois",
    everyMonth: "Tous les mois",
    everyNWeeks_one: "Toutes les {{count}} semaine",
    everyNWeeks_many: "Toutes les {{count}} semaines",
    everyNWeeks_other: "Toutes les {{count}} semaines",
    everyWeek: "Toutes les semaines",
    everyNDays_one: "Tous les {{count}} jour",
    everyNDays_many: "Tous les {{count}} jours",
    everyNDays_other: "Tous les {{count}} jours",
    everyDay: "Tous les jours",
    everyNHours_one: "Toutes les {{count}} heure",
    everyNHours_many: "Toutes les {{count}} heures",
    everyNHours_other: "Toutes les {{count}} heures",
    everyHour: "Toutes les heures",
  },
title: "Maintenance",
recordReading: "Enregistrer un relevé",
addPlan: "Ajouter un plan",
startNow: "Démarrer maintenant",
exceptions: {
lead: "La plupart des occurrences ignorées le sont pour « {{reason}} » — {{share}} % d'entre elles.",
counts: "{{skipped}} ignorés · {{missed}} manqués",
emptyDimension: "Rien d'enregistré sur ce critère pour l'instant — essayez une autre répartition.",
noSite: "Aucun site",
unassigned: "Non assigné",
by: {
reason: "Raison",
asset: "Actif",
site: "Site",
assignee: "Assigné à",
programme: "Plan de maintenance",
team: "Équipe",
},
},
card: {
  ok: "OK",
  actionFailedBody: "Rien n'a été modifié. Vérifiez votre connexion et réessayez.",
  allPlans: "Tous les plans",
heading: "Plans de maintenance",
attention_one: "{{count}} plan nécessite votre attention",
attention_other: "{{count}} plans nécessitent votre attention",
allOnTrack: "Tous les plans sont dans les délais",
pausedCount_one: "{{count}} plan en pause",
pausedCount_many: "{{count}} plans en pause",
pausedCount_other: "{{count}} plans en pause",
nextUp: "Prochain : {{what}}",
showAll: "Afficher les {{count}} plans",
showFewer: "Afficher moins",
expandHint: "Affiche ce qui arrive et les actions du plan",
status: {
job_overdue: "Intervention ouverte · en retard",
overdue: "En retard",
job_due: "Intervention ouverte · à faire maintenant",
due: "À faire maintenant",
no_reading: "Relevé nécessaire",
due_soon: "Échéance proche",
due_soon_days_one: "Échéance demain",
due_soon_days_other: "Échéance dans {{count}} jours",
due_soon_amount: "Échéance dans {{amount}}",
job: "Intervention ouverte",
waits: "Attend {{stage}}",
waits_generic: "Attend l'étape précédente",
afterStep: "Après l’étape {{n}}",
skipped: "Ignoré cette fois",
upcoming_date: "Prochain {{when}}",
upcoming_time: "Prochain à {{time}}",
upcoming_meter: "Prochain à {{amount}}",
upcoming_none: "S'exécute au démarrage",
upcoming_condition: "État surveillé",
paused: "En pause",
due_soon_days_many: "Échéance dans {{count}} jours",
},
cadence: {
manual: "Quand quelqu'un le démarre",
fixedDate: "Une fois, le {{when}}",
fixedDates_one: "À {{count}} date fixe",
fixedDates_many: "À {{count}} dates fixes",
fixedDates_other: "À {{count}} dates fixes",
condition: "Quand son état descend à {{score}} ou moins",
renewal: "Quand son document arrive à échéance de renouvellement",
byMeter: {
operating_hours: "Selon les heures machine",
mileage: "Selon le kilométrage",
cycles: "Selon les cycles",
custom_numeric: "Selon le relevé du compteur",
electricity: "Selon le compteur électrique",
gas: "Selon le compteur de gaz",
water: "Selon le compteur d’eau",
heat: "Selon le compteur de chaleur",
oil: "Selon le compteur de fioul",
},
},
comingUp: "À venir",
lastDone: "Dernière fois",
notDoneYet: "Pas encore fait",
perDay: "{{count}} par jour ensuite",
jobOpen: "Intervention ouverte",
either: "{{amount}} ou {{when}}, selon la première échéance",
nothingNext: "Rien n'est planifié. Il s'exécute quand quelqu'un le démarre.",
nothingNextCondition: "Le travail est créé lorsque le score d’état descend jusque-là.",
pausedNext: "Rien n'est créé pendant que le plan est en pause.",
steps_sequential_one: "{{count}} étape, réalisée dans l'ordre",
steps_sequential_many: "{{count}} étapes, réalisées dans l'ordre",
steps_sequential_other: "{{count}} étapes, réalisées dans l'ordre",
steps_independent_one: "{{count}} plan dans ce groupe",
steps_independent_many: "{{count}} plans dans ce groupe",
steps_independent_other: "{{count}} plans dans ce groupe",
step: "Étape {{n}}",
openJob: "Ouvrir l'intervention",
startNow: "Démarrer maintenant",
edit: "Modifier",
bringForward: "Avancer",
endStep: "Terminer l’étape",
pause: "Suspendre",
resume: "Reprendre",
end: "Terminer le plan",
endTitle: "Terminer ce plan ?",
endMessage: "Aucun nouveau travail ne sera créé. Le travail déjà créé reste dans Travail, et son historique reste sur l'actif.",
keep: "Conserver le plan",
actionFailed: "Impossible de modifier le plan",
attention_many: "{{count}} plans nécessitent votre attention",
},
startFailedTitle: "Impossible de le démarrer",
noReading: "Aucun relevé de compteur pour l'instant.",
noPlans: "Aucun plan de maintenance pour l'instant.",
plansHeading: "Plans de maintenance · {{n}}",
plansHeadingNone: "Plans de maintenance",
meters: {
heading: "Compteurs · {{n}}",
since: "{{amount}} depuis le {{when}}",
record: "Saisir un relevé",
},
emptyReadingTitle: "Aucun relevé enregistré",
emptyReadingBody: "Les plans basés sur l'usage ont besoin d'un relevé de départ pour mesurer.",
emptyPlansTitle: "Aucun plan pour le moment",
emptyPlansBody: "Appuyez sur Ajouter un plan pour un travail qui revient : un entretien, un test ou une inspection. Chacun apparaît dans Travail à son échéance.",
kind: {
mileage: "Kilométrage",
operating_hours: "Heures",
cycles: "Cycles",
electricity: "Électricité",
gas: "Gaz",
water: "Eau",
heat: "Chaleur",
oil: "Fioul",
custom_numeric: "Autre",
},
unit: {
mi: "mi",
km: "km",
h: "h",
cycles: "cycles",
},
source: {
manual: "saisi",
local_ml: "depuis une photo",
imported: "importé",
api: "API",
iot: "capteur",
},
sync: {
pending: "Enregistré sur cet appareil — sera synchronisé une fois en ligne.",
failed: "Impossible d'enregistrer — un relevé plus élevé a été enregistré en premier.",
},
rowTitle: {
due_soon_meter: "{{title}} à échéance dans {{amount}}",
due_meter: "{{title}} à faire maintenant",
overdue_meter: "{{title}} en retard de {{amount}}",
due_soon_calendar: "{{title}} échéance proche",
due_calendar: "{{title}} échéance aujourd'hui",
overdue_calendar: "{{title}} en retard",
},
sheet: {
  typeReading: "Saisissez le relevé. Une photo est conservée comme preuve ; l'application mobile peut y lire le nombre.",
  kind: "Compteur",
  noMeterId: "Sans n° de compteur",
  newMeter: "Nouveau compteur",
  meterId: "N° de compteur (facultatif)",
  meterIdPlaceholder: "Numéro de série ou de point de livraison",
  unit: "Unité",
title: "Enregistrer un relevé de compteur",
close: "Fermer",
value: "Relevé",
when: "Effectué le",
whenInvalid: "Choisissez une date et une heure valides.",
currentIs: "Actuel : {{amount}} · {{when}}",
reading: "Lecture de la photo sur cet appareil…",
detected: "Relevé de compteur détecté : {{amount}}",
trust: {
confirm: "Confirmer · lu sur cet appareil, aucun crédit IA utilisé",
check: "Vérifier · lu sur cet appareil, aucun crédit IA utilisé",
},
use: "Utiliser",
ignore: "Ignorer",
nothingDetected: "Aucun relevé trouvé dans la photo — saisissez-le. La photo est conservée comme preuve.",
lower: "C'est inférieur au relevé actuel de {{amount}}.",
outOfOrder: "Un relevé de {{amount}} est déjà enregistré après cette date. Vérifiez quand celui-ci a été effectué.",
lowerAsk: "L'enregistrer comme correction ? Le relevé précédent reste dans l'historique mais ne compte plus.",
lowerHint: "Vérifiez le chiffre, ou demandez à un responsable d'enregistrer une correction.",
correctionNote: "Pourquoi le relevé précédent est-il incorrect ?",
correctionNoteRequired: "Indiquez pourquoi le relevé précédent était incorrect.",
unitMismatch: "Ce compteur relève en {{unit}}.",
save: "Enregistrer le relevé",
saveCorrection: "Enregistrer comme correction",
saving: "Enregistrement…",
failed: "Impossible d'enregistrer le relevé.",
savedOfflineTitle: "Enregistré sur cet appareil",
savedOffline: "Sera synchronisé une fois de retour en ligne.",
recent: "Relevés récents",
correctionTag: "correction",
},
},
contractor: {
title: "Mes travaux",
view: {
new: "Nouveau",
upcoming: "À faire",
in_progress: "En cours",
awaiting_review: "En attente",
complete: "Terminé",
},
empty: {
new: "Aucune nouvelle demande pour le moment",
upcoming: "Rien de planifié",
in_progress: "Rien en cours",
awaiting_review: "Rien chez le client",
complete: "Rien de terminé pour l’instant",
},
emptyHint: {
new: "Les invitations et les demandes de devis apparaîtront ici.",
upcoming: "Les interventions que vous avez acceptées apparaîtront ici.",
in_progress: "Démarrez une intervention depuis À venir une fois sur place.",
awaiting_review: "Ce que vous envoyez attend ici sa validation.",
complete: "Les travaux validés par le client apparaîtront ici.",
},
quoteFallbackTitle: "Demande de devis",
clientOther: "Autres",
next: {
quote: "Envoyez un prix ou refusez",
waitingClient: "En attente du client",
},
notLinked: {
title: "Pas encore enregistré comme prestataire",
body: "Demandez à votre client de vous ajouter avec l’adresse e-mail utilisée à l’inscription, et ses travaux apparaîtront ici.",
bodyWithEmail: "Demandez à votre client de vous ajouter comme prestataire avec l’adresse {{email}}. Ses interventions et demandes de devis apparaîtront ici.",
checkAgain: "Vérifier à nouveau",
checking: "Vérification…",
},
loadFailed: {
title: "Votre travail ne s’est pas chargé",
body: "Vérifiez votre connexion, puis touchez Réessayer.",
retry: "Réessayer",
},
},
planning: {
  lockedHint: "Placez les visites sur des personnes et des horaires, voyez les trajets et obtenez un plan proposé pour la journée.",
  leave: {
    message_other: "Vous avez {{count}} changements de plan pas encore enregistrés. Abandonnez-les, ou continuez à planifier et appuyez sur Appliquer.",
    message_many: "Vous avez {{count}} changements de plan pas encore enregistrés. Abandonnez-les, ou continuez à planifier et appuyez sur Appliquer.",
    message_one: "Vous avez {{count}} changement de plan pas encore enregistré. Abandonnez-le, ou continuez à planifier et appuyez sur Appliquer.",
    discard: "Abandonner les changements",
    keep: "Continuer à planifier",
    title: "Quitter sans enregistrer le plan ?",
  },
range: {
day: "Jour",
threeDay: "3 jours",
week: "Semaine",
month: "Mois",
agenda: "2 semaines",
a11y: "Période du calendrier",
},
nav: {
previousA11y: "Plus tôt",
nextA11y: "Plus tard",
today: "Aujourd'hui",
todayA11y: "Aller à aujourd'hui",
},
lane: {
unassigned: "Non attribué",
you: "Vous",
unnamed: "Personne sans nom",
notWorking: "Ne travaille pas",
timeOff: "Absent",
more: "+{{count}} de plus",
moreA11y: "Afficher {{count}} de plus à {{time}}",
showLess: "Afficher moins",
load: "{{percent}} % planifié · {{work}}",
capacityA11y: "{{name}} : {{percent}} % de la journée est planifié",
},
summary: {
jobs_one: "{{count}} intervention",
jobs_many: "{{count}} interventions",
jobs_other: "{{count}} interventions",
work: "{{duration}} de travail",
travel: "{{duration}} de trajet",
travelEstimated: "environ {{duration}} de trajet",
travelUnknown_one: "{{count}} trajet sans position",
travelUnknown_many: "{{count}} trajets sans position",
travelUnknown_other: "{{count}} trajets sans position",
free: "{{duration}} libres",
overtime: "{{duration}} d'heures supplémentaires",
},
readiness: {
ready: "Prêts {{count}}",
parts: "Pièces manquantes {{count}}",
capacity: "Personne de libre ou de compétent {{count}}",
other: "En attente {{count}}",
defer: "Peuvent attendre {{count}}",
},
unplanned: {
nobody: "A une heure, mais personne",
title: "Non planifié · {{count}}",
empty: "Tout ce qui est affiché est planifié.",
filterDue: "À échéance",
filterAll: "Tous",
filterA11y: "Quel travail non planifié afficher",
due: "Échéance {{date}}",
overdue: "En retard",
},
reason: {
parts_unavailable: "Pièce indisponible",
technician_unavailable: "Personne de disponible",
skill_missing: "Compétence indisponible",
dependency: "En attente d'un autre travail",
no_capacity: "Aucune capacité",
location_missing: "Aucun emplacement",
appointment_conflict: "Rendez-vous impossible à tenir",
outside_hours: "Hors des heures de travail",
awaiting_approval: "En attente d'approbation",
declined: "Refusé",
crew_unavailable: "Pas assez de personnes libres en même temps",
},
signal: {
overlap: "Double réservation",
insufficient_travel: "Temps de trajet insuffisant",
skill_missing: "Compétence manquante",
parts_unavailable: "Pièce indisponible",
outside_appointment: "Hors du rendez-vous",
outside_hours: "Hors des heures de travail",
technician_unavailable: "Absent",
dependency_unmet: "En attente d'un autre travail",
after_due: "Après la date d'échéance",
urgent: "Priorité élevée",
parts_ready: "Pièces prêtes",
parts_unknown: "Pièces non confirmées",
appointment: "Créneau de rendez-vous",
awaiting_acceptance: "En attente d'acceptation",
confirmed: "Confirmé",
locked: "Heure verrouillée",
duration_default: "Durée estimée",
duration_learned: "Durée habituelle",
multi_day: "Sur plusieurs jours",
crew_visit: "En tant que membre de l’équipe",
via_pickup: "Retrait de pièce en chemin",
},
state: {
pending: "Suggéré",
in_progress: "En cours",
done: "Terminé",
},
travel: {
block: "{{duration}} de trajet · {{distance}}",
estimated: "environ {{duration}} de trajet · {{distance}}",
a11y: "Trajet : {{duration}}",
estimateNote: "Le trajet est estimé à partir de la distance à vol d’oiseau, à vitesse urbaine et sans trafic. Appuyez sur un trajet pour le vérifier dans l’application de cartes.",
roadNote: "Le trajet est un temps de route habituel, sans trafic en temps réel. Appuyez sur un trajet pour le vérifier dans l’application de cartes.",
short: "{{duration}} de trajet",
shortEstimated: "environ {{duration}} de trajet",
},
week: {
legend: {
work: "Travail",
travel: "Trajet",
free: "Libre",
overtime: "Hors horaires",
},
openDayA11y: "Planifier le {{day}}",
cellA11y: "{{name}}, {{day}} : {{percent}} % planifié, {{work}} de travail, {{travel}} de trajet",
cellOffA11y: "{{name}}, {{day}} : ne travaille pas",
percent: "{{percent}} %",
free: "Libre",
hoursUnknown: "Horaires inconnus",
unplannedDue: "Non planifié, à échéance",
forecast: "Avec le travail prévu",
forecastOver: "Dépasse de {{duration}}",
forecastFits: "Tient",
},
panel: {
assignedTo: "Attribué à",
nobody: "Personne pour l’instant. Choisissez qui s’en charge.",
partArrives: "Si la pièce arrive le",
planFromThen: "Planifier à partir de là",
makeRoom: "Faire de la place",
makeRoomHint: "Cela tombe sur une autre intervention. Lui proposer une autre place.",
day: "Jour",
start: "Début",
length: "Durée",
ends: "Se termine à {{time}}",
notPlanned: "Non planifié",
moreNotes_one: "{{count}} note de plus",
moreNotes_many: "{{count}} notes de plus",
moreNotes_other: "{{count}} notes de plus",
fewerNotes: "Moins de notes",
staged: "Pas encore enregistré",
fixed: "Ce travail a commencé ou est confirmé : il reste où il est.",
awaitingApproval: "En attente d’approbation. Il ne peut pas encore être planifié.",
previousDayA11y: "La veille",
nextDayA11y: "Le lendemain",
earlierA11y: "Commencer 15 minutes plus tôt",
laterA11y: "Commencer 15 minutes plus tard",
shorterA11y: "15 minutes de moins",
longerA11y: "15 minutes de plus",
remove: "Retirer du plan",
pin: "Verrouiller cette heure",
unpin: "Déverrouiller l’heure",
undo: "Annuler la modification",
open: "Ouvrir",
closeA11y: "Fermer le panneau du plan",
},
apply: {
changes_one: "{{count}} modification non enregistrée",
changes_many: "{{count}} modifications non enregistrées",
changes_other: "{{count}} modifications non enregistrées",
notifies: "Appliquer prévient {{names}}",
discard: "Abandonner",
apply: "Appliquer",
breaks: "Enfreint une règle : {{rules}}",
reasonLabel: "Raison de poursuivre",
reload: "Recharger",
done: "Plan enregistré",
conflict: "Quelqu’un d’autre a modifié {{days}} pendant votre planification. Rechargez pour le voir. Vos modifications sont conservées.",
failed_one: "{{count}} modification n’a pas pu être enregistrée : {{message}}",
failed_many: "{{count}} modifications n’ont pas pu être enregistrées. La première : {{message}}",
failed_other: "{{count}} modifications n’ont pas pu être enregistrées. La première : {{message}}",
error: "Le plan n’a pas pu être enregistré. {{message}}",
partial: "{{applied}} modifications sur {{requested}} appliquées",
none_one: "La modification n’a pas pu être appliquée",
none_many: "Aucune des {{count}} modifications n’a pu être appliquée",
none_other: "Aucune des {{count}} modifications n’a pu être appliquée",
unsettled: "Les modifications ont été écrites mais le résultat n’a pas pu être confirmé. Rechargez pour vérifier le plan.",
reviewIssues_one: "Examiner {{count}} problème",
reviewIssues_many: "Examiner {{count}} problèmes",
reviewIssues_other: "Examiner {{count}} problèmes",
issues: {
title: "Modifications non appliquées",
appliedLine_one: "{{count}} modification appliquée",
appliedLine_many: "{{count}} modifications appliquées",
appliedLine_other: "{{count}} modifications appliquées",
retry: "Réessayer les échecs",
keep: "Garder ce qui est appliqué",
discardRest: "Abandonner le reste",
open: "Ouvrir",
closeA11y: "Fermer l’examen des modifications non appliquées",
code: {
refused: "Non autorisé",
not_persisted: "Non enregistré",
unverified: "Enregistrement non vérifié",
missing: "N’existe plus",
},
},
recover: "Une mise à jour précédente du plan ne s’est pas terminée.",
recoverAction: "Examiner",
recovered: {
applied: "La mise à jour précédente avait été entièrement appliquée.",
failed: "Rien de la mise à jour précédente n’avait été appliqué.",
},
stale: "Quelqu’un a modifié {{days}} après vos changements. Vérifiez le tableau, puis gardez ou abandonnez vos changements.",
staleAction: "Garder mes changements",
overrideNote: "{{rule}}, outrepassé : {{reason}}",
},
optimise: {
action: "Proposer un plan",
title: "Plan suggéré",
whatIfA11y: "Et si {{name}} est absent ?",
whyShow: "Pourquoi ce plan",
whyHide: "Masquer les raisons",
scenarioOff: "Et si {{name}} est absent(e)",
scenarioArrival: "Et si la pièce arrive le {{date}}",
scenarioNote: "Un simple aperçu. Rien ne change tant que vous n’appuyez pas sur Utiliser ce plan.",
working: "Calcul du plan… {{seconds}} s",
stop: "Arrêter",
useScenario: "Utiliser ce plan",
closeA11y: "Fermer le plan suggéré",
removeA11y: "Laisser {{title}} tel quel",
why: {
placed: "Placé parce que : {{list}}.",
held: "Toujours non planifié : {{list}}.",
reason: "{{count}} × {{reason}}",
blocker: "{{count}} × {{reason}}",
join: " · ",
},
whyReason: {
required_skill: "la compétence requise",
parts_ready: "pièces prêtes",
due_today: "dû ce jour-là",
urgent: "priorité haute",
near_previous: "près de l’arrêt précédent",
same_site: "déjà sur le site",
keeps_assignee: "reste avec la même personne",
saves_travel: "économise du trajet",
after_overrun: "après le dépassement",
from_position: "depuis l’endroit où la personne se trouve",
overtime: "au-delà de la journée",
with_crew: "avec l’équipe",
via_pickup: "via un retrait",
swapped: "échangé entre personnes",
fits_capacity: "tient dans la journée",
},
extraPerson: "Et avec une personne de plus ?",
extraPersonTakes_one: "Une personne de plus prendrait {{count}} intervention de plus.",
extraPersonTakes_many: "Une personne de plus prendrait {{count}} interventions de plus.",
extraPersonTakes_other: "Une personne de plus prendrait {{count}} interventions de plus.",
extraPersonNone: "Une personne de plus ne changerait pas le plan.",
none: "Rien à améliorer : le plan convient déjà.",
planned: "Planifié {{before}} → {{after}}",
travel: "Trajet {{before}} → {{after}}",
stillUnplanned_one: "{{count}} toujours non planifié",
stillUnplanned_many: "{{count}} toujours non planifiés",
stillUnplanned_other: "{{count}} toujours non planifiés",
confidence: {
high: "Confiance élevée",
medium: "Confiance moyenne",
low: "Confiance faible",
},
note: {
parts_unknown_one: "Pièces non confirmées pour {{count}} intervention",
parts_unknown_many: "Pièces non confirmées pour {{count}} interventions",
parts_unknown_other: "Pièces non confirmées pour {{count}} interventions",
location_missing_one: "{{count}} intervention sans emplacement",
location_missing_many: "{{count}} interventions sans emplacement",
location_missing_other: "{{count}} interventions sans emplacement",
duration_default_one: "{{count}} intervention utilise une durée estimée",
duration_default_many: "{{count}} interventions utilisent une durée estimée",
duration_default_other: "{{count}} interventions utilisent une durée estimée",
travel_estimated_one: "Trajet estimé pour {{count}} déplacement",
travel_estimated_many: "Trajet estimé pour {{count}} déplacements",
travel_estimated_other: "Trajet estimé pour {{count}} déplacements",
},
reason: {
required_skill: "Possède la compétence requise",
parts_ready: "Pièces prêtes",
due_today: "À faire ce jour-là",
urgent: "Priorité élevée",
near_previous: "À {{duration}} de l’arrêt précédent",
same_site: "Déjà sur ce site",
fits_capacity: "Tient dans la journée",
keeps_assignee: "Reste avec la même personne",
saves_travel: "Économise {{duration}} de trajet",
after_overrun: "Commence quand l’intervention précédente peut se terminer",
from_position: "Commence quand la personne peut y arriver depuis l’endroit où elle se trouve",
overtime: "{{duration}} au-delà de la journée",
with_crew: "Placé avec l’équipe au même moment",
via_pickup: "Passe par le retrait de la pièce",
swapped: "Échangé avec une autre personne, économise {{duration}}",
},
},
schedulePlan: {
save: "Enregistrer le plan",
failed: "Enregistrement impossible. {{message}}",
},
myDay: {
  boardHint: "Vous voyez ici la journée de toute l’équipe. Pour déplacer du travail entre les personnes sur le tableau du jour, ouvrez Travail sur une tablette ou un ordinateur.",
  title: "Ma journée",
saved: "Enregistré {{time}} · pas de connexion, dernière copie affichée",
savedWide: "Enregistré {{time}} · serveur injoignable, dernière copie affichée. Rien ne peut être appliqué d’ici là.",
changed: "Votre plan a changé entre-temps : {{moved}} déplacé(s), {{added}} nouveau(x), {{removed}} retiré(s).",
changedDismissA11y: "Fermer la note sur les changements",
mine: "Ma journée",
everyone: "Tout le monde",
switchA11y: "La journée de qui afficher",
accept: "Accepter",
decline: "Refuser",
accepted: "Accepté",
acceptFailed: "Impossible d’accepter. {{message}}",
startNext: "Commencer le suivant : {{title}}",
},
insights: {
eyebrow: "Planification du travail",
title: "Où en est le plan",
subtitle: "Les {{days}} derniers jours",
none: "—",
utilisation: "Au travail, pas en route",
utilisationCaption: "du temps planifié",
utilisationInfo: "Part du travail dans le temps total de travail et de trajet, sur chaque journée planifiée de la période. Le trajet n’est jamais du temps productif.",
adherence: "Commencées comme prévu",
adherenceCaption_one: "sur {{count}} intervention planifiée",
adherenceCaption_many: "sur {{count}} interventions planifiées",
adherenceCaption_other: "sur {{count}} interventions planifiées",
adherenceInfo: "Interventions planifiées commencées dans les {{minutes}} minutes de l’heure prévue.",
actual: "Durée réelle vs prévue",
actualCaption_one: "médiane de {{count}} intervention",
actualCaption_many: "médiane de {{count}} interventions",
actualCaption_other: "médiane de {{count}} interventions",
actualInfo: "Le temps réellement pris par les interventions terminées, en part de la durée prévue. 100 % = comme prévu ; au-delà, les plans sont trop courts.",
},
directions: {
action: "Itinéraire",
route: "Tournée",
routeA11y: "Ouvrir la tournée de {{name}} dans l’application de cartes",
legA11y: "Ouvre ce trajet dans l’application de cartes",
partsTitle: "Cette tournée s’ouvre en plusieurs parties",
partsBody: "Un lien de carte accepte un nombre limité d’arrêts. Choisissez la partie à ouvrir.",
part: "Arrêts {{from}}–{{to}}",
cancel: "Annuler",
},
map: {
show: "Carte",
hide: "Tableau",
hideNarrow: "Liste",
empty: "Rien de ce qui est planifié ce jour-là n’a d’emplacement.",
unplannedNearby_one: "{{count}} non planifiée, avec une position",
unplannedNearby_many: "{{count}} non planifiées, avec une position",
unplannedNearby_other: "{{count}} non planifiées, avec une position",
stopA11y: "Arrêt {{number}} : {{title}}",
noLocation_one: "{{count}} sans emplacement",
noLocation_many: "{{count}} sans emplacement",
noLocation_other: "{{count}} sans emplacement",
legend: "Les lignes en pointillés relient les arrêts dans l’ordre. Ce n’est pas la route.",
},
home: {
title: "Plan du jour",
count_one: "{{count}} intervention",
count_many: "{{count}} interventions",
count_other: "{{count}} interventions",
withNext_one: "{{count}} intervention · prochaine {{time}} {{title}}",
withNext_many: "{{count}} interventions · prochaine {{time}} {{title}}",
withNext_other: "{{count}} interventions · prochaine {{time}} {{title}}",
},
settings: {
title: "Réglages de planification",
closeA11y: "Fermer les réglages de planification",
week: "Semaine de travail",
starts: "Début de journée",
ends: "Fin de journée",
break: "Pause",
noBreak: "Aucune",
defaults: "Quand rien n’est précisé",
jobLength: "Une intervention dure",
inspectionLength: "Une inspection dure",
citySpeed: "Conduite en ville",
citySpeedHint: "Sert à estimer le trajet quand aucun temps routier n’est connu. Les longs trajets sont supposés plus rapides.",
save: "Enregistrer",
failed: "Enregistrement impossible. {{message}}",
person: "Pour {{name}}",
personHours: "Ses horaires",
ownHours: "Les siens",
sameHours: "Ceux de l’espace de travail",
personDepot: "Où sa journée commence et finit",
savePerson: "Enregistrer pour cette personne",
overtime: "Les plans proposés peuvent dépasser la journée de",
noOvertime: "Jamais",
overtimeHint: "Les plans proposés l’évitent quand ils le peuvent. Un changement au-delà de la journée est signalé et demande un motif avant d’être appliqué.",
depot: "Où la journée commence et finit",
noDepot: "Non défini",
depotHint: "Un site. Les premier et dernier trajets de la journée comptent à partir d’ici.",
usePositions: "Utiliser la position des personnes",
usePositionsHint: "Chaque personne choisit de partager sa position, et seulement lorsque l’application est ouverte. Seuls les propriétaires et les administrateurs la voient, pour repérer un retard. Seule la dernière position est conservée, pendant deux heures.",
clearDepot: "Effacer",
lessA11y: "Moins : {{label}}",
moreA11y: "Plus : {{label}}",
timeOff: "Absences le {{day}}",
removeOffA11y: "Retirer l’absence de {{name}}",
off: {
allDay: "Toute la journée",
morning: "Matin",
afternoon: "Après-midi",
},
},
parts: {
title: "Pièces nécessaires",
empty: "Aucune pièce indiquée. Ajoutez ce qu’il faut apporter.",
addLabel: "Pièce ou matériel",
add: "Ajouter une pièce",
removeA11y: "Retirer {{part}}",
failed: "La pièce n’a pas pu être enregistrée. {{message}}",
availability: {
unknown: "Non confirmée",
available: "Disponible",
reserved: "Réservée",
unavailable: "Indisponible",
},
heldAt: "Stockée à {{site}}",
notHeld: "Où est-elle stockée ?",
clearHeld: "Effacer",
},
jobPlanning: {
title: "Planification",
people: "Personnes en même temps",
fewerA11y: "Moins de personnes",
moreA11y: "Plus de personnes",
appointment: "Doit avoir lieu entre",
on: "Le",
from: "De",
to: "À",
saveAppointment: "Enregistrer le créneau",
clearAppointment: "Effacer le créneau",
window: "{{on}}, {{from}}–{{to}}",
noWindow: "N’importe quand",
waitsOn: "Attend",
waitsOnNone: "Rien",
removeDepA11y: "N’attend plus {{title}}",
addDepA11y: "Attendre {{title}}",
failed: "Enregistrement impossible. {{message}}",
},
refine: {
planningTitle: "Planification",
partsTitle: "Pièces",
planning: {
planned: "Planifié",
unplanned: "Non planifié",
blocked: "Bloqué",
},
parts: {
ready: "Prêtes",
unavailable: "Indisponibles",
unknown: "Non confirmées",
},
},
lanes: {
a11y: "Les colonnes affichent",
people: "Par personne",
site: "Par site",
asset: "Par équipement",
noSite: "Aucun site",
noAsset: "Aucun équipement",
},
review: {
overrun: "{{title}} dépasse de {{duration}}. Le reste de la journée de {{name}} ne tient plus.",
absence_one: "{{name}} est absent sur {{count}} intervention planifiée.",
absence_many: "{{name}} est absent sur {{count}} interventions planifiées.",
absence_other: "{{name}} est absent sur {{count}} interventions planifiées.",
urgent_one: "{{count}} intervention urgente n’est pas planifiée.",
urgent_many: "{{count}} interventions urgentes ne sont pas planifiées.",
urgent_other: "{{count}} interventions urgentes ne sont pas planifiées.",
part_unavailable: "Une pièce pour {{title}} n’est plus disponible.",
cancelled: "{{title}} a été annulée : son créneau est libre.",
early_finish: "{{name}} a terminé {{title}} en avance : il reste du temps.",
running_late: "{{name}} aura environ {{duration}} de retard pour {{title}}, depuis l’endroit où la personne se trouve.",
more: "+{{count}} de plus",
action: "Revoir le plan",
dismissA11y: "Mettre de côté",
nothing: "Rien ne peut être déplacé pour régler cela. Il faut en décider à la main.",
},
position: {
  stop: "Arrêter le partage",
  share: "Partager ma position",
sharingShort: "Position partagée",
stopA11y: "Arrêter de partager votre position",
offer: "Partagez votre position pendant le travail, pour que votre journée puisse être ajustée en cas de retard.",
explainTitle: "Partager votre position ?",
explain: "Tant que cette application est ouverte et que vous avez du travail aujourd’hui, votre position est envoyée toutes les quelques minutes. Seuls les propriétaires et les administrateurs de votre espace de travail la voient, pour repérer un retard sur votre prochaine visite. Seule la dernière position est conservée, elle est effacée au bout de deux heures, et vous pouvez arrêter à tout moment.",
explainConfirm: "Partager tant que l’application est ouverte",
explainCancel: "Pas maintenant",
denied: "La localisation est désactivée pour cette application. Autorisez-la dans les réglages de l’appareil pour partager votre position.",
failed: "Impossible de modifier le partage. {{message}}",
fromYou: "Environ {{duration}} de vous jusqu’à {{title}}",
seen: "Vu il y a {{duration}}",
seenNow: "Vu à l’instant",
},
slot: {
createA11y: "Créer une intervention à {{time}}",
clear: "Aucun conflit avec sa journée",
},
rail: {
allDay: "Toute la journée",
forecast: "Prévision",
forecastA11y: "Prévision, pas encore réservée : {{title}}",
},
agenda: {
empty: "Rien n'est planifié pour ce jour. Les flèches changent de jour.",
},
error: {
  tryAgain: "Réessayez dans un instant.",
  offline: "Vérifiez votre connexion et réessayez.",
  notAllowed: "Vous n’avez pas l’autorisation de modifier cela.",
load: "Le plan n'a pas pu être chargé.",
retry: "Réessayer",
},
loadingA11y: "Chargement du plan",
truncated: "Il y a plus de travail sur ces jours que le calendrier n'en charge. Réduisez la vue avec Affiner.",
},
scheduler: {
  contractor: {
    giveNow: "Confier au prestataire",
    pick: "Choisir un prestataire",
    change: "{{name}} · Modifier",
    hint: "Il la reçoit dans Mon travail et doit avoir un compte AssetWRX. Vous la validez toujours.",
    missing: "Choisissez le prestataire qui fera cette inspection.",
  },
  fitLine: {
    bestAvailable: "Meilleur choix disponible",
    goodFit: "Bonne adéquation",
    line: "Meilleur choix : {{name}} · {{score}} % d’adéquation · {{why}}",
  },
  fitReason: {
    certification: "A une certification requise",
    withinRange: "À distance raisonnable",
    closeToSite: "Proche du site",
    available: "Indiqué comme disponible",
    team: "Dans l’équipe responsable de ce travail",
    capacity: "A du temps libre",
    lightlyBooked: "Seulement {{n}} h planifiées",
    nothingBooked: "Rien de planifié",
    onTime: "Termine généralement à temps",
    verifiedHistory: "Son travail est généralement vérifié",
    assetTypeExperience: "Expérience avec ce type d’actif",
    priorWorkOnAsset: "A déjà travaillé sur cet actif",
    skillsMatch: "A les compétences requises",
    categoryMany: "{{n}} interventions terminées dans cette catégorie",
    categoryOne: "1 intervention terminée dans cette catégorie",
  },
  blocker: {
    not_assignable: "Ne peut pas recevoir de travail",
    inactive_contractor: "Le sous-traitant n’est pas actif",
    no_site_access: "Pas d’accès à ce site",
    unavailable: "Indisponible à ce moment-là",
    missing_certification: "Il manque une certification requise",
    missing_mandatory_skill: "Il manque une compétence requise",
  },
  slotReason: {
    afterDue: "Après l’échéance",
    sameSite: "Même site que l’intervention précédente",
    beforeDue: "Avant l’échéance",
    minutes: "{{n}} min",
    hours: "{{n}} h",
    gapFree: "Créneau libre de {{duration}}",
    firstGap: "Premier créneau libre de {{duration}}",
  },
  notes: {
    revert: "Rétablir",
    discard: "Abandonner",
    accept: "Accepter",
    tidyFailedTitle: "Impossible d'améliorer la note",
    tidiedReview: "Vérifiez-la, puis touchez Accepter.",
    tidiedTitle: "Note retravaillée",
    tidyUp: "Améliorer avec l'IA",
    stop: "Arrêter",
    dictate: "Dicter",
  },
  assignee: {
    noMatch: "Personne dans votre équipe ne correspond.",
    search: "Rechercher dans votre équipe",
    blocked: "indisponible",
    contractor: "Prestataire",
    technician: "Technicien",
    notEligibleItem: "{{name}} ({{reason}})",
    notEligible: "Ne peut pas la prendre : {{list}}",
    bestMatch: "Meilleur choix : {{name}}",
    assignA11y: "Assigner {{name}}",
    recommended: "Recommandé : {{name}}",
    youSuffix: "{{name}} (vous)",
    you: "Vous",
  },
  invite: {
    description: "Liste de contrôle : {{checklist}}",
    title: "Inspection : {{asset}}",
  },
  errors: {
    photosOtherWorkspace: "Vos photos sont conservées pour l'espace de travail où vous avez créé cette intervention. Revenez-y, puis touchez Terminer l'enregistrement.",
    otherWorkspace: "Revenez à l'espace de travail où vous avez créé cette intervention, puis touchez Terminer l'enregistrement.",
    pickTime: "Choisissez une date et une heure, puis réessayez.",
  },
  errorTitles: {
    reschedule: "Nouvel horaire non enregistré",
    jobLater: "Intervention non planifiée",
    jobNow: "Intervention non créée",
    inspectionLater: "Inspection non planifiée",
    inspectionNow: "Inspection non démarrée",
  },
  checklist: {
    noMatch: "Aucune liste de contrôle ne correspond. Essayez un autre mot ou touchez Nouvelle liste de contrôle.",
    search: "Rechercher une liste de contrôle",
    add: "Ajouter",
    done: "Terminé",
    change: "Changer",
    picked: "Vous avez choisi celle-ci.",
    loadFailed: "Vos listes de contrôle ne se sont pas chargées.",
    loading: "Chargement des listes de contrôle…",
  },
  slotAfterDue: "après la date d'échéance",
  moreSummaryShort: "Mode d'exécution et rappels",
  renewing: "Renouvellement de {{title}}. Cette inspection enregistre les preuves du renouvellement.",
  renewingJob: "Renouvellement de {{title}}. Une fois cette intervention terminée, créez-en le certificat de remplacement.",
  renewJobTitle: "Renouveler {{title}}",
  fromRequest: "Depuis la demande : {{title}}",
  runMode: {
    list: "Liste",
    guided_group: "Par section",
    guided_item: "Une étape à la fois",
  },
  reminder: {
    "2day": "2 jours avant",
    "1day": "1 jour avant",
    "2hr": "2 heures avant",
    "1hr": "1 heure avant",
    "30min": "30 minutes avant",
    "15min": "15 minutes avant",
    at_time: "À l'heure prévue",
  },
  cta: {
    scheduleJob: "Planifier l'intervention",
    scheduleInspection: "Planifier l'inspection",
    createJob: "Créer l'intervention",
    startInspection: "Démarrer l'inspection",
    saveTime: "Enregistrer l'horaire",
    finishJob: "Terminer l'enregistrement",
  },
  heading: {
    job: "Intervention · {{asset}}",
    inspection: "Inspection de {{asset}}",
    rescheduleJob: "Replanifier l'intervention",
    rescheduleInspection: "Replanifier l'inspection",
  },
  done: {
    jobCreated: "Intervention créée pour {{asset}}.",
    jobScheduled: "Intervention pour {{asset}} prévue le {{when}}.",
    jobCreatedPhotos: "Intervention créée. Photos enregistrées sur cet appareil pour envoi.",
    jobRescheduled: "Intervention pour {{asset}} déplacée au {{when}}.",
    open: "Ouvrir",
    inspectionRepeats: "Inspection de {{asset}} prévue le {{when}}. Répétition : {{how}}.",
    inspectionScheduled: "Inspection de {{asset}} prévue le {{when}}. Elle apparaît dans Travail ce jour-là.",
    inspectionRescheduled: "Inspection de {{asset}} déplacée au {{when}}.",
  },
  hide: "Masquer",
  moreSummary: "Mode d'exécution, rappels, notes et responsable",
  errorBody: "Rien n'a été enregistré. Vérifiez votre connexion et réessayez.",
  errorPartialTitle: "Intervention créée ; enregistrement incomplet",
  repeat: {
    advance: {
      on_calendar: "Aux dates prévues",
      on_completion: "Après la fin de celle-ci",
    },
    nextFrom: "Quand la suivante est-elle due ?",
    noLimit: "Sans limite",
    maxTimes: "Arrêter après (fois)",
    use: "Utiliser {{how}}",
    suggested: "Suggestion : {{how}}. {{why}}",
    planHint: "Pour répéter selon un relevé de compteur ou à des dates fixes, ajoutez plutôt un plan de maintenance sur l'actif.",
    errorMax: "Indiquez combien de fois, ou laissez vide.",
    errorEndBeforeStart: "La répétition ne peut pas se terminer avant la première intervention.",
    errorEnd: "Choisissez le jour où la répétition se termine.",
  },
show: "Afficher",
},
workItemCopy: {
issues_one: "{{count}} problème",
issues_many: "{{count}} de problèmes",
issues_other: "{{count}} problèmes",
inspectionFallback: "Inspection",
},
assistantCards: {
draftFindingPhoto: "Rédiger un constat à partir de la photo",
suggestTriagePriority: "Suggérer une priorité de tri",
recurringRaisesPriority: "Un problème récurrent augmenterait la priorité.",
suggestRepair_one: "Suggérer une réparation pour {{count}} élément en échec",
suggestRepair_many: "Suggérer une réparation pour {{count}} d’éléments en échec",
suggestRepair_other: "Suggérer une réparation pour {{count}} éléments en échec",
checkExistingRepair: "Vérifiez d’abord la réparation existante — il s’agit peut-être d’un doublon.",
draftFindingEvidence: "Rédiger un constat à partir des preuves",
suggestPriority: "Suggérer une priorité",
suggestContractor: "Suggérer le prestataire le plus adapté",
contractorRecurring: "Un même prestataire résout régulièrement les travaux sur cet actif.",
verifyEvidence: "Vérifier les preuves d’achèvement",
suggestFollowUp: "Suggérer une action de suivi",
verifyBeforeSignOff: "Vérifier les preuves d’achèvement avant la validation",
summariseJourney: "Résumer le parcours pour le rapport",
summarisePortfolio: "Résumer le parcours du portefeuille",
portfolioRisk: "Risque {{band}} pour le portefeuille ({{score}}/100)",
riskBandLow: "faible",
riskBandMedium: "moyen",
riskBandHigh: "élevé",
},
evidenceLocal: {
identifierVin: "VIN {{value}}",
identifierSerial: "N° de série {{value}}",
identifierOther: "Identifiant {{value}}",
codes_one: "{{count}} code",
codes_many: "{{count}} de codes",
codes_other: "{{count}} codes",
readings_one: "{{count}} relevé",
readings_many: "{{count}} de relevés",
readings_other: "{{count}} relevés",
complianceLabel: "étiquette {{scheme}}",
dates_one: "{{count}} date",
dates_many: "{{count}} de dates",
dates_other: "{{count}} dates",
recognised: "Reconnu : {{label}}. Aucune donnée structurée trouvée sur l’appareil.",
nothingFound: "Aucune information extraite sur l’appareil.",
found: "Trouvé sur l’appareil : {{parts}}.",
separator: ", ",
mobileOnly: "L’analyse sur l’appareil se fait dans l’application mobile.",
failed: "Impossible d’analyser les preuves sur l’appareil.",
},
fitRisks: {
missesDueDates: "Manque souvent les échéances",
repeatReopens: "Réouvertures répétées sur des travaux récents",
someRework: "Quelques reprises sur des interventions passées",
hoursCommitted_one: "{{count}} h déjà engagée",
hoursCommitted_many: "{{count}} h déjà engagées",
hoursCommitted_other: "{{count}} h déjà engagées",
heavyWorkload: "Charge de travail actuelle très lourde",
elevatedWorkload: "Charge de travail active élevée",
overdueAssignments_one: "{{count}} attribution en retard",
overdueAssignments_many: "{{count}} d’attributions en retard",
overdueAssignments_other: "{{count}} attributions en retard",
},
journeySignals: {
whereAsset: "sur cet actif",
wherePortfolio: "sur l’ensemble du portefeuille",
alreadyRepairedLabel: "Une réparation {{where}} a déjà été effectuée.",
alreadyRepairedDetailAgo_one: "La dernière intervention terminée {{where}} a été clôturée il y a {{count}} j — vérifiez qu’il ne s’agit pas d’un doublon avant de créer de nouveaux travaux.",
alreadyRepairedDetailAgo_many: "La dernière intervention terminée {{where}} a été clôturée il y a {{count}} j — vérifiez qu’il ne s’agit pas d’un doublon avant de créer de nouveaux travaux.",
alreadyRepairedDetailAgo_other: "La dernière intervention terminée {{where}} a été clôturée il y a {{count}} j — vérifiez qu’il ne s’agit pas d’un doublon avant de créer de nouveaux travaux.",
alreadyRepairedDetail: "Une intervention terminée existe déjà {{where}} — vérifiez qu’il ne s’agit pas d’un doublon avant de créer de nouveaux travaux.",
recurringLabel_one: "{{count}} intervention ou constat distinct enregistré {{where}}.",
recurringLabel_many: "{{count}} d’interventions ou de constats distincts enregistrés {{where}}.",
recurringLabel_other: "{{count}} interventions ou constats distincts enregistrés {{where}}.",
recurringDetail_one: "{{count}} élément de travail {{where}} a abouti à une intervention ou à un constat au cours des {{days}} derniers jours — un actif qui revient souvent en maintenance mérite peut-être une recherche de la cause profonde plutôt qu’une nouvelle réparation ponctuelle.",
recurringDetail_many: "{{count}} d’éléments de travail {{where}} ont abouti à une intervention ou à un constat au cours des {{days}} derniers jours — un actif qui revient souvent en maintenance mérite peut-être une recherche de la cause profonde plutôt qu’une nouvelle réparation ponctuelle.",
recurringDetail_other: "{{count}} éléments de travail {{where}} ont abouti à une intervention ou à un constat au cours des {{days}} derniers jours — un actif qui revient souvent en maintenance mérite peut-être une recherche de la cause profonde plutôt qu’une nouvelle réparation ponctuelle.",
contractorLabel_one: "{{name}} a résolu {{count}} intervention {{where}}.",
contractorLabel_many: "{{name}} a résolu {{count}} d’interventions {{where}}.",
contractorLabel_other: "{{name}} a résolu {{count}} interventions {{where}}.",
contractorDetail: "Des appels répétés au même prestataire peuvent signaler une cause profonde non résolue.",
healthLabel_one: "La santé de l’actif se dégrade (baisse de {{count}} point).",
healthLabel_many: "La santé de l’actif se dégrade (baisse de {{count}} de points).",
healthLabel_other: "La santé de l’actif se dégrade (baisse de {{count}} points).",
healthDetail: "La santé opérationnelle est passée de {{then}} à {{now}} — traitez cet actif en priorité avant qu’il n’atteigne l’état « Action recommandée ».",
overdueLabel_one: "{{count}} suivi ouvert {{where}} est en retard.",
overdueLabel_many: "{{count}} de suivis ouverts {{where}} sont en retard.",
overdueLabel_other: "{{count}} suivis ouverts {{where}} sont en retard.",
overdueDetail: "Des parcours ouverts {{where}} ont dépassé le SLA d’au moins une étape — ils risquent de prendre encore plus de retard.",
},
suggestJobCopy: {
noInspectionData: "Aucune donnée d’inspection fournie pour suggérer des interventions.",
noSuggestions: "Aucune suggestion d’intervention pour cette inspection.",
suggestionsReady_one: "{{count}} suggestion d’intervention prête.",
suggestionsReady_many: "{{count}} de suggestions d’intervention prêtes.",
suggestionsReady_other: "{{count}} suggestions d’intervention prêtes.",
addRequestSummary: "Ajoutez un résumé de la demande pour suggérer une intervention.",
derivedFromRequest: "Suggestion d’intervention tirée de la demande.",
derivedWarning: "Tirée de la demande (sans IA). Confirmez avant de créer l’intervention.",
enableAi: "Activez l’IA pour suggérer une intervention de suivi.",
enableAiHint: "Utilisez l’IA pour générer une suggestion d’intervention de suivi.",
offline: "Suggestion de l’IA indisponible hors ligne.",
offlineWarning: "Suggestion de l’IA indisponible hors ligne",
followUpFailed: "Impossible de suggérer une intervention de suivi.",
notAvailable: "Les suggestions d’intervention ne sont pas disponibles dans ce contexte.",
suggestionFailed: "Échec de la suggestion",
jobFailed: "Impossible de suggérer une intervention.",
},
rules: {
title: "Règles de groupe",
subtitle: "Répéter une liste de contrôle sur de nombreux actifs",
intro: "Une règle de groupe applique la même liste de contrôle à chaque actif correspondant, par exemple chaque porte coupe-feu du bâtiment A chaque mois. Les nouveaux actifs correspondants la rejoignent d’eux-mêmes.",
howTitle: "Comment fonctionnent les règles de groupe",
howStep1: "Choisissez le groupe : une catégorie d’actif, un de vos types d’actif, un type de lieu ou une zone. Vous pouvez le limiter à ce qui se trouve dans un lieu.",
howStep2: "Choisissez la liste de contrôle, la fréquence et la date de la première inspection.",
howStep3: "L’enregistrement crée une inspection pour chaque actif du groupe. Un actif qui arrive plus tard reçoit la sienne ; pour un actif qui sort du groupe, l’inspection non commencée est annulée.",
howExample: "Exemple : « Contrôle mensuel des portes coupe-feu » prend chaque porte coupe-feu du bâtiment A. L’enregistrement crée 24 inspections, prévues à la première date. Sur la page Travail, elles apparaissent sur une seule ligne.",
howEdits: "Modifier une règle met à jour ses inspections non commencées. Les inspections commencées ou terminées ne changent jamais. Arrêter une règle annule celles qui n’ont pas commencé.",
howTour: "Montrez-moi",
howGuide: "Lire le guide",
add: "Ajouter une règle de groupe",
newTitle: "Nouvelle règle de groupe",
editTitle: "Modifier la règle de groupe",
nameLabel: "Nom",
namePlaceholder: "Contrôle mensuel des portes coupe-feu",
nameRequired: "Donnez un nom à la règle",
whatLabel: "Quels actifs",
whatHint: "Choisissez d’abord une catégorie d’actif.",
anyPlace: "Tout lieu",
whereLabel: "Où",
whereHint: "Dans un lieu inclut tout ce qu’il contient, à toutes les profondeurs : les étages d’un bâtiment, leurs pièces et ce qui y est installé.",
anywhere: "Partout",
aPlace: "un lieu",
someType: "Un type d’actif",
anyAsset: "Tout actif",
inZone: "dans la zone {{zone}}",
insidePlace: "dans {{place}}",
assignedTo: "à {{name}}",
zoneLabel: "Zone (facultatif)",
zoneHint: "Uniquement les actifs avec cette zone.",
checklistLabel: "Liste de contrôle",
pickChecklist: "Choisir une liste de contrôle",
checklistRequired: "Choisissez une liste de contrôle",
searchChecklists: "Rechercher des listes de contrôle",
howOftenLabel: "Fréquence",
startsOnLabel: "Première inspection le",
startsOnInvalid: "Saisissez une date au format AAAA-MM-JJ",
assigneeLabel: "Attribuer à (facultatif)",
assigneeHint: "La personne est prévenue une seule fois, quel que soit le nombre d’inspections créées.",
nobody: "Personne pour l’instant",
someone: "Quelqu’un",
you: "{{name}} (vous)",
searchPeople: "Rechercher des personnes",
needsGroup: "Choisissez une catégorie d’actif, un type d’actif, un type de lieu ou une zone.",
sentence: "{{recurrence}} à partir du {{date}} : chaque {{what}}{{where}} reçoit la liste de contrôle « {{checklist}} ».",
sentenceNoChecklist: "{{recurrence}} à partir du {{date}} : chaque {{what}}{{where}}. Choisissez une liste de contrôle pour terminer.",
sentenceNeedsGroup: "Indiquez quels actifs pour voir la règle ici.",
sentenceInside: " dans {{place}}",
sentenceInZone: " dans la zone {{zone}}",
sentenceAssigned: "Attribuée à {{name}}.",
counting: "Comptage…",
estimate_one: "Elle prend {{count}} actif en ce moment.",
estimate_many: "Elle prend {{count}} actifs en ce moment.",
estimate_other: "Elle prend {{count}} actifs en ce moment.",
estimateHint: "Un actif qui rejoint le groupe plus tard reçoit sa propre inspection, prévue le jour où il arrive.",
estimateOffline: "Compté à partir des actifs de cet appareil, car le serveur est injoignable. La règle couvre quand même chaque correspondance.",
editUpdates_one: "L’enregistrement met à jour {{count}} inspection non commencée.",
editUpdates_many: "L’enregistrement met à jour {{count}} inspections non commencées.",
editUpdates_other: "L’enregistrement met à jour {{count}} inspections non commencées.",
editLeaving_one: "{{count}} inspection sera annulée : son actif ne fait plus partie du groupe.",
editLeaving_many: "{{count}} inspections seront annulées : leurs actifs ne font plus partie du groupe.",
editLeaving_other: "{{count}} inspections seront annulées : leurs actifs ne font plus partie du groupe.",
editJoining_one: "{{count}} nouvelle inspection sera créée.",
editJoining_many: "{{count}} nouvelles inspections seront créées.",
editJoining_other: "{{count}} nouvelles inspections seront créées.",
editKept: "Les inspections commencées ou terminées ne changent pas.",
cancel: "Annuler",
save: "Enregistrer la règle",
saved_one: "Enregistré. {{count}} inspection est prévue.",
saved_many: "Enregistré. {{count}} inspections sont prévues.",
saved_other: "Enregistré. {{count}} inspections sont prévues.",
failedTitle: "Impossible d’enregistrer la règle",
failedBody: "Vérifiez votre connexion et réessayez.",
active: "Active",
stopped: "Arrêtée",
savedMoreComing_one: "Enregistré. {{count}} inspection est prévue pour l’instant ; les autres sont ajoutées ou mises à jour dans les prochaines minutes.",
savedMoreComing_many: "Enregistré. {{count}} inspections sont prévues pour l’instant ; les autres sont ajoutées ou mises à jour dans les prochaines minutes.",
savedMoreComing_other: "Enregistré. {{count}} inspections sont prévues pour l’instant ; les autres sont ajoutées ou mises à jour dans les prochaines minutes.",
moreComing: "Inspections en cours d’ajout ou de mise à jour. Revenez dans quelques minutes.",
openVisits_one: "{{count}} inspection ouverte",
openVisits_many: "{{count}} inspections ouvertes",
openVisits_other: "{{count}} inspections ouvertes",
fromRuleLabel: "Issue d’une règle de groupe",
edit: "Modifier",
stop: "Arrêter",
restart: "Relancer",
stopConfirmTitle: "Arrêter cette règle ?",
stopConfirmBody_one: "Son inspection non commencée ({{count}}) sera annulée. Les inspections terminées restent.",
stopConfirmBody_many: "Ses {{count}} inspections non commencées seront annulées. Les inspections terminées restent.",
stopConfirmBody_other: "Ses {{count}} inspections non commencées seront annulées. Les inspections terminées restent.",
emptyTitle: "Aucune règle de groupe pour l’instant",
emptyBody: "Un propriétaire ou un administrateur les configure. Leurs inspections apparaissent ensuite sur la page Travail comme les autres.",
emptyBodyAdmin: "Ajoutez votre première règle pour inspecter tout un groupe d’actifs selon un même calendrier.",
foldedRow_one: "{{name}} · {{count}} actif",
foldedRow_many: "{{name}} · {{count}} actifs",
foldedRow_other: "{{name}} · {{count}} actifs",
},
rounds: {
title: "Lancer une tournée",
intro: "Une intervention qui parcourt les lieux et éléments dans {{place}}. Chaque arrêt a sa propre liste de contrôle.",
stopsLabel: "Arrêts",
stopCount_one: "{{count}} arrêt",
stopCount_many: "{{count}} arrêts",
stopCount_other: "{{count}} arrêts",
all: "Tous",
none: "Aucun",
loading: "Lecture du contenu…",
tooMany: "Une tournée compte au maximum {{max}} arrêts. Décochez-en quelques-uns.",
titleLabel: "Nom de la tournée",
defaultTitle: "Tournée {{checklist}} : {{place}}",
dateLabel: "Date (facultatif)",
dateHint: "AAAA-MM-JJ. Laissez vide pour la planifier plus tard.",
description_one: "Tournée de {{count}} arrêt dans {{place}}.",
description_many: "Tournée de {{count}} arrêts dans {{place}}.",
description_other: "Tournée de {{count}} arrêts dans {{place}}.",
create_one: "Lancer la tournée avec {{count}} arrêt",
create_many: "Lancer la tournée avec {{count}} arrêts",
create_other: "Lancer la tournée avec {{count}} arrêts",
created_one: "Tournée lancée avec {{count}} arrêt",
created_many: "Tournée lancée avec {{count}} arrêts",
created_other: "Tournée lancée avec {{count}} arrêts",
failedTitle: "Impossible de lancer la tournée",
failedBody: "Rien n’a été créé. Vérifiez votre connexion et réessayez.",
emptyTitle: "Rien à visiter ici",
emptyBody: "Ajoutez d’abord des lieux ou des équipements dans ce lieu, ou changez les filtres.",
},
};
